function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 1440,
  height: 1056,
  fill: "url(#paint0_radial_53029_6911)"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_53029_6911)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M35 0H34V1056H35V0Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M84 0H83V1056H84V0Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133 0H132V1056H133V0Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M182 0H181V1056H182V0Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M231 0H230V1056H231V0Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M280 0H279V1056H280V0Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M329 0H328V1056H329V0Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M378 0H377V1056H378V0Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M427 0H426V1056H427V0Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M476 0H475V1056H476V0Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M525 0H524V1056H525V0Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M574 0H573V1056H574V0Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M623 0H622V1056H623V0Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M672 0H671V1056H672V0Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M721 0H720V1056H721V0Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M770 0H769V1056H770V0Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M819 0H818V1056H819V0Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M868 0H867V1056H868V0Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M917 0H916V1056H917V0Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M966 0H965V1056H966V0Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1015 0H1014V1056H1015V0Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1064 0H1063V1056H1064V0Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1113 0H1112V1056H1113V0Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1162 0H1161V1056H1162V0Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1211 0H1210V1056H1211V0Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1260 0H1259V1056H1260V0Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1309 0H1308V1056H1309V0Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1358 0H1357V1056H1358V0Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1407 0H1406V1056H1407V0Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1440 38H0V39H1440V38Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1440 87H0V88H1440V87Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1440 136H0V137H1440V136Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1440 185H0V186H1440V185Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1440 234H0V235H1440V234Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1440 283H0V284H1440V283Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1440 332H0V333H1440V332Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1440 381H0V382H1440V381Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1440 430H0V431H1440V430Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1440 479H0V480H1440V479Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1440 528H0V529H1440V528Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1440 577H0V578H1440V577Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1440 626H0V627H1440V626Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1440 675H0V676H1440V675Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1440 724H0V725H1440V724Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1440 773H0V774H1440V773Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1440 822H0V823H1440V822Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1440 871H0V872H1440V871Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1440 920H0V921H1440V920Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1440 969H0V970H1440V969Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1440 1018H0V1019H1440V1018Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.5 40.5C35.6046 40.5 36.5 39.6046 36.5 38.5C36.5 37.3954 35.6046 36.5 34.5 36.5C33.3954 36.5 32.5 37.3954 32.5 38.5C32.5 39.6046 33.3954 40.5 34.5 40.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.5 40.5C84.6046 40.5 85.5 39.6046 85.5 38.5C85.5 37.3954 84.6046 36.5 83.5 36.5C82.3954 36.5 81.5 37.3954 81.5 38.5C81.5 39.6046 82.3954 40.5 83.5 40.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132.5 40.5C133.605 40.5 134.5 39.6046 134.5 38.5C134.5 37.3954 133.605 36.5 132.5 36.5C131.395 36.5 130.5 37.3954 130.5 38.5C130.5 39.6046 131.395 40.5 132.5 40.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M181.5 40.5C182.605 40.5 183.5 39.6046 183.5 38.5C183.5 37.3954 182.605 36.5 181.5 36.5C180.395 36.5 179.5 37.3954 179.5 38.5C179.5 39.6046 180.395 40.5 181.5 40.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M230.5 40.5C231.605 40.5 232.5 39.6046 232.5 38.5C232.5 37.3954 231.605 36.5 230.5 36.5C229.395 36.5 228.5 37.3954 228.5 38.5C228.5 39.6046 229.395 40.5 230.5 40.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M279.5 40.5C280.605 40.5 281.5 39.6046 281.5 38.5C281.5 37.3954 280.605 36.5 279.5 36.5C278.395 36.5 277.5 37.3954 277.5 38.5C277.5 39.6046 278.395 40.5 279.5 40.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M328.5 40.5C329.605 40.5 330.5 39.6046 330.5 38.5C330.5 37.3954 329.605 36.5 328.5 36.5C327.395 36.5 326.5 37.3954 326.5 38.5C326.5 39.6046 327.395 40.5 328.5 40.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M377.5 40.5C378.605 40.5 379.5 39.6046 379.5 38.5C379.5 37.3954 378.605 36.5 377.5 36.5C376.395 36.5 375.5 37.3954 375.5 38.5C375.5 39.6046 376.395 40.5 377.5 40.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M426.5 40.5C427.605 40.5 428.5 39.6046 428.5 38.5C428.5 37.3954 427.605 36.5 426.5 36.5C425.395 36.5 424.5 37.3954 424.5 38.5C424.5 39.6046 425.395 40.5 426.5 40.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M475.5 40.5C476.605 40.5 477.5 39.6046 477.5 38.5C477.5 37.3954 476.605 36.5 475.5 36.5C474.395 36.5 473.5 37.3954 473.5 38.5C473.5 39.6046 474.395 40.5 475.5 40.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M524.5 40.5C525.605 40.5 526.5 39.6046 526.5 38.5C526.5 37.3954 525.605 36.5 524.5 36.5C523.395 36.5 522.5 37.3954 522.5 38.5C522.5 39.6046 523.395 40.5 524.5 40.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M573.5 40.5C574.605 40.5 575.5 39.6046 575.5 38.5C575.5 37.3954 574.605 36.5 573.5 36.5C572.395 36.5 571.5 37.3954 571.5 38.5C571.5 39.6046 572.395 40.5 573.5 40.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M622.5 40.5C623.605 40.5 624.5 39.6046 624.5 38.5C624.5 37.3954 623.605 36.5 622.5 36.5C621.395 36.5 620.5 37.3954 620.5 38.5C620.5 39.6046 621.395 40.5 622.5 40.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M671.5 40.5C672.605 40.5 673.5 39.6046 673.5 38.5C673.5 37.3954 672.605 36.5 671.5 36.5C670.395 36.5 669.5 37.3954 669.5 38.5C669.5 39.6046 670.395 40.5 671.5 40.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M720.5 40.5C721.605 40.5 722.5 39.6046 722.5 38.5C722.5 37.3954 721.605 36.5 720.5 36.5C719.395 36.5 718.5 37.3954 718.5 38.5C718.5 39.6046 719.395 40.5 720.5 40.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M769.5 40.5C770.605 40.5 771.5 39.6046 771.5 38.5C771.5 37.3954 770.605 36.5 769.5 36.5C768.395 36.5 767.5 37.3954 767.5 38.5C767.5 39.6046 768.395 40.5 769.5 40.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M818.5 40.5C819.605 40.5 820.5 39.6046 820.5 38.5C820.5 37.3954 819.605 36.5 818.5 36.5C817.395 36.5 816.5 37.3954 816.5 38.5C816.5 39.6046 817.395 40.5 818.5 40.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M867.5 40.5C868.605 40.5 869.5 39.6046 869.5 38.5C869.5 37.3954 868.605 36.5 867.5 36.5C866.395 36.5 865.5 37.3954 865.5 38.5C865.5 39.6046 866.395 40.5 867.5 40.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M916.5 40.5C917.605 40.5 918.5 39.6046 918.5 38.5C918.5 37.3954 917.605 36.5 916.5 36.5C915.395 36.5 914.5 37.3954 914.5 38.5C914.5 39.6046 915.395 40.5 916.5 40.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M965.5 40.5C966.605 40.5 967.5 39.6046 967.5 38.5C967.5 37.3954 966.605 36.5 965.5 36.5C964.395 36.5 963.5 37.3954 963.5 38.5C963.5 39.6046 964.395 40.5 965.5 40.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1014.5 40.5C1015.6 40.5 1016.5 39.6046 1016.5 38.5C1016.5 37.3954 1015.6 36.5 1014.5 36.5C1013.4 36.5 1012.5 37.3954 1012.5 38.5C1012.5 39.6046 1013.4 40.5 1014.5 40.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1063.5 40.5C1064.6 40.5 1065.5 39.6046 1065.5 38.5C1065.5 37.3954 1064.6 36.5 1063.5 36.5C1062.4 36.5 1061.5 37.3954 1061.5 38.5C1061.5 39.6046 1062.4 40.5 1063.5 40.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1112.5 40.5C1113.6 40.5 1114.5 39.6046 1114.5 38.5C1114.5 37.3954 1113.6 36.5 1112.5 36.5C1111.4 36.5 1110.5 37.3954 1110.5 38.5C1110.5 39.6046 1111.4 40.5 1112.5 40.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1161.5 40.5C1162.6 40.5 1163.5 39.6046 1163.5 38.5C1163.5 37.3954 1162.6 36.5 1161.5 36.5C1160.4 36.5 1159.5 37.3954 1159.5 38.5C1159.5 39.6046 1160.4 40.5 1161.5 40.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1210.5 40.5C1211.6 40.5 1212.5 39.6046 1212.5 38.5C1212.5 37.3954 1211.6 36.5 1210.5 36.5C1209.4 36.5 1208.5 37.3954 1208.5 38.5C1208.5 39.6046 1209.4 40.5 1210.5 40.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1259.5 40.5C1260.6 40.5 1261.5 39.6046 1261.5 38.5C1261.5 37.3954 1260.6 36.5 1259.5 36.5C1258.4 36.5 1257.5 37.3954 1257.5 38.5C1257.5 39.6046 1258.4 40.5 1259.5 40.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1308.5 40.5C1309.6 40.5 1310.5 39.6046 1310.5 38.5C1310.5 37.3954 1309.6 36.5 1308.5 36.5C1307.4 36.5 1306.5 37.3954 1306.5 38.5C1306.5 39.6046 1307.4 40.5 1308.5 40.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1357.5 40.5C1358.6 40.5 1359.5 39.6046 1359.5 38.5C1359.5 37.3954 1358.6 36.5 1357.5 36.5C1356.4 36.5 1355.5 37.3954 1355.5 38.5C1355.5 39.6046 1356.4 40.5 1357.5 40.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1406.5 40.5C1407.6 40.5 1408.5 39.6046 1408.5 38.5C1408.5 37.3954 1407.6 36.5 1406.5 36.5C1405.4 36.5 1404.5 37.3954 1404.5 38.5C1404.5 39.6046 1405.4 40.5 1406.5 40.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.5 89.5C35.6046 89.5 36.5 88.6046 36.5 87.5C36.5 86.3954 35.6046 85.5 34.5 85.5C33.3954 85.5 32.5 86.3954 32.5 87.5C32.5 88.6046 33.3954 89.5 34.5 89.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.5 89.5C84.6046 89.5 85.5 88.6046 85.5 87.5C85.5 86.3954 84.6046 85.5 83.5 85.5C82.3954 85.5 81.5 86.3954 81.5 87.5C81.5 88.6046 82.3954 89.5 83.5 89.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132.5 89.5C133.605 89.5 134.5 88.6046 134.5 87.5C134.5 86.3954 133.605 85.5 132.5 85.5C131.395 85.5 130.5 86.3954 130.5 87.5C130.5 88.6046 131.395 89.5 132.5 89.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M181.5 89.5C182.605 89.5 183.5 88.6046 183.5 87.5C183.5 86.3954 182.605 85.5 181.5 85.5C180.395 85.5 179.5 86.3954 179.5 87.5C179.5 88.6046 180.395 89.5 181.5 89.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M230.5 89.5C231.605 89.5 232.5 88.6046 232.5 87.5C232.5 86.3954 231.605 85.5 230.5 85.5C229.395 85.5 228.5 86.3954 228.5 87.5C228.5 88.6046 229.395 89.5 230.5 89.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M279.5 89.5C280.605 89.5 281.5 88.6046 281.5 87.5C281.5 86.3954 280.605 85.5 279.5 85.5C278.395 85.5 277.5 86.3954 277.5 87.5C277.5 88.6046 278.395 89.5 279.5 89.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M328.5 89.5C329.605 89.5 330.5 88.6046 330.5 87.5C330.5 86.3954 329.605 85.5 328.5 85.5C327.395 85.5 326.5 86.3954 326.5 87.5C326.5 88.6046 327.395 89.5 328.5 89.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M377.5 89.5C378.605 89.5 379.5 88.6046 379.5 87.5C379.5 86.3954 378.605 85.5 377.5 85.5C376.395 85.5 375.5 86.3954 375.5 87.5C375.5 88.6046 376.395 89.5 377.5 89.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M426.5 89.5C427.605 89.5 428.5 88.6046 428.5 87.5C428.5 86.3954 427.605 85.5 426.5 85.5C425.395 85.5 424.5 86.3954 424.5 87.5C424.5 88.6046 425.395 89.5 426.5 89.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M475.5 89.5C476.605 89.5 477.5 88.6046 477.5 87.5C477.5 86.3954 476.605 85.5 475.5 85.5C474.395 85.5 473.5 86.3954 473.5 87.5C473.5 88.6046 474.395 89.5 475.5 89.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M524.5 89.5C525.605 89.5 526.5 88.6046 526.5 87.5C526.5 86.3954 525.605 85.5 524.5 85.5C523.395 85.5 522.5 86.3954 522.5 87.5C522.5 88.6046 523.395 89.5 524.5 89.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M573.5 89.5C574.605 89.5 575.5 88.6046 575.5 87.5C575.5 86.3954 574.605 85.5 573.5 85.5C572.395 85.5 571.5 86.3954 571.5 87.5C571.5 88.6046 572.395 89.5 573.5 89.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M622.5 89.5C623.605 89.5 624.5 88.6046 624.5 87.5C624.5 86.3954 623.605 85.5 622.5 85.5C621.395 85.5 620.5 86.3954 620.5 87.5C620.5 88.6046 621.395 89.5 622.5 89.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M671.5 89.5C672.605 89.5 673.5 88.6046 673.5 87.5C673.5 86.3954 672.605 85.5 671.5 85.5C670.395 85.5 669.5 86.3954 669.5 87.5C669.5 88.6046 670.395 89.5 671.5 89.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M720.5 89.5C721.605 89.5 722.5 88.6046 722.5 87.5C722.5 86.3954 721.605 85.5 720.5 85.5C719.395 85.5 718.5 86.3954 718.5 87.5C718.5 88.6046 719.395 89.5 720.5 89.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M769.5 89.5C770.605 89.5 771.5 88.6046 771.5 87.5C771.5 86.3954 770.605 85.5 769.5 85.5C768.395 85.5 767.5 86.3954 767.5 87.5C767.5 88.6046 768.395 89.5 769.5 89.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M818.5 89.5C819.605 89.5 820.5 88.6046 820.5 87.5C820.5 86.3954 819.605 85.5 818.5 85.5C817.395 85.5 816.5 86.3954 816.5 87.5C816.5 88.6046 817.395 89.5 818.5 89.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M867.5 89.5C868.605 89.5 869.5 88.6046 869.5 87.5C869.5 86.3954 868.605 85.5 867.5 85.5C866.395 85.5 865.5 86.3954 865.5 87.5C865.5 88.6046 866.395 89.5 867.5 89.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M916.5 89.5C917.605 89.5 918.5 88.6046 918.5 87.5C918.5 86.3954 917.605 85.5 916.5 85.5C915.395 85.5 914.5 86.3954 914.5 87.5C914.5 88.6046 915.395 89.5 916.5 89.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M965.5 89.5C966.605 89.5 967.5 88.6046 967.5 87.5C967.5 86.3954 966.605 85.5 965.5 85.5C964.395 85.5 963.5 86.3954 963.5 87.5C963.5 88.6046 964.395 89.5 965.5 89.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1014.5 89.5C1015.6 89.5 1016.5 88.6046 1016.5 87.5C1016.5 86.3954 1015.6 85.5 1014.5 85.5C1013.4 85.5 1012.5 86.3954 1012.5 87.5C1012.5 88.6046 1013.4 89.5 1014.5 89.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1063.5 89.5C1064.6 89.5 1065.5 88.6046 1065.5 87.5C1065.5 86.3954 1064.6 85.5 1063.5 85.5C1062.4 85.5 1061.5 86.3954 1061.5 87.5C1061.5 88.6046 1062.4 89.5 1063.5 89.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1112.5 89.5C1113.6 89.5 1114.5 88.6046 1114.5 87.5C1114.5 86.3954 1113.6 85.5 1112.5 85.5C1111.4 85.5 1110.5 86.3954 1110.5 87.5C1110.5 88.6046 1111.4 89.5 1112.5 89.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1161.5 89.5C1162.6 89.5 1163.5 88.6046 1163.5 87.5C1163.5 86.3954 1162.6 85.5 1161.5 85.5C1160.4 85.5 1159.5 86.3954 1159.5 87.5C1159.5 88.6046 1160.4 89.5 1161.5 89.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1210.5 89.5C1211.6 89.5 1212.5 88.6046 1212.5 87.5C1212.5 86.3954 1211.6 85.5 1210.5 85.5C1209.4 85.5 1208.5 86.3954 1208.5 87.5C1208.5 88.6046 1209.4 89.5 1210.5 89.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1259.5 89.5C1260.6 89.5 1261.5 88.6046 1261.5 87.5C1261.5 86.3954 1260.6 85.5 1259.5 85.5C1258.4 85.5 1257.5 86.3954 1257.5 87.5C1257.5 88.6046 1258.4 89.5 1259.5 89.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1308.5 89.5C1309.6 89.5 1310.5 88.6046 1310.5 87.5C1310.5 86.3954 1309.6 85.5 1308.5 85.5C1307.4 85.5 1306.5 86.3954 1306.5 87.5C1306.5 88.6046 1307.4 89.5 1308.5 89.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1357.5 89.5C1358.6 89.5 1359.5 88.6046 1359.5 87.5C1359.5 86.3954 1358.6 85.5 1357.5 85.5C1356.4 85.5 1355.5 86.3954 1355.5 87.5C1355.5 88.6046 1356.4 89.5 1357.5 89.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1406.5 89.5C1407.6 89.5 1408.5 88.6046 1408.5 87.5C1408.5 86.3954 1407.6 85.5 1406.5 85.5C1405.4 85.5 1404.5 86.3954 1404.5 87.5C1404.5 88.6046 1405.4 89.5 1406.5 89.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.5 138.5C35.6046 138.5 36.5 137.605 36.5 136.5C36.5 135.395 35.6046 134.5 34.5 134.5C33.3954 134.5 32.5 135.395 32.5 136.5C32.5 137.605 33.3954 138.5 34.5 138.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.5 138.5C84.6046 138.5 85.5 137.605 85.5 136.5C85.5 135.395 84.6046 134.5 83.5 134.5C82.3954 134.5 81.5 135.395 81.5 136.5C81.5 137.605 82.3954 138.5 83.5 138.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132.5 138.5C133.605 138.5 134.5 137.605 134.5 136.5C134.5 135.395 133.605 134.5 132.5 134.5C131.395 134.5 130.5 135.395 130.5 136.5C130.5 137.605 131.395 138.5 132.5 138.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M181.5 138.5C182.605 138.5 183.5 137.605 183.5 136.5C183.5 135.395 182.605 134.5 181.5 134.5C180.395 134.5 179.5 135.395 179.5 136.5C179.5 137.605 180.395 138.5 181.5 138.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M230.5 138.5C231.605 138.5 232.5 137.605 232.5 136.5C232.5 135.395 231.605 134.5 230.5 134.5C229.395 134.5 228.5 135.395 228.5 136.5C228.5 137.605 229.395 138.5 230.5 138.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M279.5 138.5C280.605 138.5 281.5 137.605 281.5 136.5C281.5 135.395 280.605 134.5 279.5 134.5C278.395 134.5 277.5 135.395 277.5 136.5C277.5 137.605 278.395 138.5 279.5 138.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M328.5 138.5C329.605 138.5 330.5 137.605 330.5 136.5C330.5 135.395 329.605 134.5 328.5 134.5C327.395 134.5 326.5 135.395 326.5 136.5C326.5 137.605 327.395 138.5 328.5 138.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M377.5 138.5C378.605 138.5 379.5 137.605 379.5 136.5C379.5 135.395 378.605 134.5 377.5 134.5C376.395 134.5 375.5 135.395 375.5 136.5C375.5 137.605 376.395 138.5 377.5 138.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M426.5 138.5C427.605 138.5 428.5 137.605 428.5 136.5C428.5 135.395 427.605 134.5 426.5 134.5C425.395 134.5 424.5 135.395 424.5 136.5C424.5 137.605 425.395 138.5 426.5 138.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M475.5 138.5C476.605 138.5 477.5 137.605 477.5 136.5C477.5 135.395 476.605 134.5 475.5 134.5C474.395 134.5 473.5 135.395 473.5 136.5C473.5 137.605 474.395 138.5 475.5 138.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M524.5 138.5C525.605 138.5 526.5 137.605 526.5 136.5C526.5 135.395 525.605 134.5 524.5 134.5C523.395 134.5 522.5 135.395 522.5 136.5C522.5 137.605 523.395 138.5 524.5 138.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M573.5 138.5C574.605 138.5 575.5 137.605 575.5 136.5C575.5 135.395 574.605 134.5 573.5 134.5C572.395 134.5 571.5 135.395 571.5 136.5C571.5 137.605 572.395 138.5 573.5 138.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M622.5 138.5C623.605 138.5 624.5 137.605 624.5 136.5C624.5 135.395 623.605 134.5 622.5 134.5C621.395 134.5 620.5 135.395 620.5 136.5C620.5 137.605 621.395 138.5 622.5 138.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M671.5 138.5C672.605 138.5 673.5 137.605 673.5 136.5C673.5 135.395 672.605 134.5 671.5 134.5C670.395 134.5 669.5 135.395 669.5 136.5C669.5 137.605 670.395 138.5 671.5 138.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M720.5 138.5C721.605 138.5 722.5 137.605 722.5 136.5C722.5 135.395 721.605 134.5 720.5 134.5C719.395 134.5 718.5 135.395 718.5 136.5C718.5 137.605 719.395 138.5 720.5 138.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M769.5 138.5C770.605 138.5 771.5 137.605 771.5 136.5C771.5 135.395 770.605 134.5 769.5 134.5C768.395 134.5 767.5 135.395 767.5 136.5C767.5 137.605 768.395 138.5 769.5 138.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M818.5 138.5C819.605 138.5 820.5 137.605 820.5 136.5C820.5 135.395 819.605 134.5 818.5 134.5C817.395 134.5 816.5 135.395 816.5 136.5C816.5 137.605 817.395 138.5 818.5 138.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M867.5 138.5C868.605 138.5 869.5 137.605 869.5 136.5C869.5 135.395 868.605 134.5 867.5 134.5C866.395 134.5 865.5 135.395 865.5 136.5C865.5 137.605 866.395 138.5 867.5 138.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M916.5 138.5C917.605 138.5 918.5 137.605 918.5 136.5C918.5 135.395 917.605 134.5 916.5 134.5C915.395 134.5 914.5 135.395 914.5 136.5C914.5 137.605 915.395 138.5 916.5 138.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M965.5 138.5C966.605 138.5 967.5 137.605 967.5 136.5C967.5 135.395 966.605 134.5 965.5 134.5C964.395 134.5 963.5 135.395 963.5 136.5C963.5 137.605 964.395 138.5 965.5 138.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1014.5 138.5C1015.6 138.5 1016.5 137.605 1016.5 136.5C1016.5 135.395 1015.6 134.5 1014.5 134.5C1013.4 134.5 1012.5 135.395 1012.5 136.5C1012.5 137.605 1013.4 138.5 1014.5 138.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1063.5 138.5C1064.6 138.5 1065.5 137.605 1065.5 136.5C1065.5 135.395 1064.6 134.5 1063.5 134.5C1062.4 134.5 1061.5 135.395 1061.5 136.5C1061.5 137.605 1062.4 138.5 1063.5 138.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1112.5 138.5C1113.6 138.5 1114.5 137.605 1114.5 136.5C1114.5 135.395 1113.6 134.5 1112.5 134.5C1111.4 134.5 1110.5 135.395 1110.5 136.5C1110.5 137.605 1111.4 138.5 1112.5 138.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1161.5 138.5C1162.6 138.5 1163.5 137.605 1163.5 136.5C1163.5 135.395 1162.6 134.5 1161.5 134.5C1160.4 134.5 1159.5 135.395 1159.5 136.5C1159.5 137.605 1160.4 138.5 1161.5 138.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1210.5 138.5C1211.6 138.5 1212.5 137.605 1212.5 136.5C1212.5 135.395 1211.6 134.5 1210.5 134.5C1209.4 134.5 1208.5 135.395 1208.5 136.5C1208.5 137.605 1209.4 138.5 1210.5 138.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1259.5 138.5C1260.6 138.5 1261.5 137.605 1261.5 136.5C1261.5 135.395 1260.6 134.5 1259.5 134.5C1258.4 134.5 1257.5 135.395 1257.5 136.5C1257.5 137.605 1258.4 138.5 1259.5 138.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1308.5 138.5C1309.6 138.5 1310.5 137.605 1310.5 136.5C1310.5 135.395 1309.6 134.5 1308.5 134.5C1307.4 134.5 1306.5 135.395 1306.5 136.5C1306.5 137.605 1307.4 138.5 1308.5 138.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1357.5 138.5C1358.6 138.5 1359.5 137.605 1359.5 136.5C1359.5 135.395 1358.6 134.5 1357.5 134.5C1356.4 134.5 1355.5 135.395 1355.5 136.5C1355.5 137.605 1356.4 138.5 1357.5 138.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1406.5 138.5C1407.6 138.5 1408.5 137.605 1408.5 136.5C1408.5 135.395 1407.6 134.5 1406.5 134.5C1405.4 134.5 1404.5 135.395 1404.5 136.5C1404.5 137.605 1405.4 138.5 1406.5 138.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.5 187.5C35.6046 187.5 36.5 186.605 36.5 185.5C36.5 184.395 35.6046 183.5 34.5 183.5C33.3954 183.5 32.5 184.395 32.5 185.5C32.5 186.605 33.3954 187.5 34.5 187.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.5 187.5C84.6046 187.5 85.5 186.605 85.5 185.5C85.5 184.395 84.6046 183.5 83.5 183.5C82.3954 183.5 81.5 184.395 81.5 185.5C81.5 186.605 82.3954 187.5 83.5 187.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132.5 187.5C133.605 187.5 134.5 186.605 134.5 185.5C134.5 184.395 133.605 183.5 132.5 183.5C131.395 183.5 130.5 184.395 130.5 185.5C130.5 186.605 131.395 187.5 132.5 187.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M181.5 187.5C182.605 187.5 183.5 186.605 183.5 185.5C183.5 184.395 182.605 183.5 181.5 183.5C180.395 183.5 179.5 184.395 179.5 185.5C179.5 186.605 180.395 187.5 181.5 187.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M230.5 187.5C231.605 187.5 232.5 186.605 232.5 185.5C232.5 184.395 231.605 183.5 230.5 183.5C229.395 183.5 228.5 184.395 228.5 185.5C228.5 186.605 229.395 187.5 230.5 187.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M279.5 187.5C280.605 187.5 281.5 186.605 281.5 185.5C281.5 184.395 280.605 183.5 279.5 183.5C278.395 183.5 277.5 184.395 277.5 185.5C277.5 186.605 278.395 187.5 279.5 187.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M328.5 187.5C329.605 187.5 330.5 186.605 330.5 185.5C330.5 184.395 329.605 183.5 328.5 183.5C327.395 183.5 326.5 184.395 326.5 185.5C326.5 186.605 327.395 187.5 328.5 187.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M377.5 187.5C378.605 187.5 379.5 186.605 379.5 185.5C379.5 184.395 378.605 183.5 377.5 183.5C376.395 183.5 375.5 184.395 375.5 185.5C375.5 186.605 376.395 187.5 377.5 187.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M426.5 187.5C427.605 187.5 428.5 186.605 428.5 185.5C428.5 184.395 427.605 183.5 426.5 183.5C425.395 183.5 424.5 184.395 424.5 185.5C424.5 186.605 425.395 187.5 426.5 187.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M475.5 187.5C476.605 187.5 477.5 186.605 477.5 185.5C477.5 184.395 476.605 183.5 475.5 183.5C474.395 183.5 473.5 184.395 473.5 185.5C473.5 186.605 474.395 187.5 475.5 187.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M524.5 187.5C525.605 187.5 526.5 186.605 526.5 185.5C526.5 184.395 525.605 183.5 524.5 183.5C523.395 183.5 522.5 184.395 522.5 185.5C522.5 186.605 523.395 187.5 524.5 187.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M573.5 187.5C574.605 187.5 575.5 186.605 575.5 185.5C575.5 184.395 574.605 183.5 573.5 183.5C572.395 183.5 571.5 184.395 571.5 185.5C571.5 186.605 572.395 187.5 573.5 187.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M622.5 187.5C623.605 187.5 624.5 186.605 624.5 185.5C624.5 184.395 623.605 183.5 622.5 183.5C621.395 183.5 620.5 184.395 620.5 185.5C620.5 186.605 621.395 187.5 622.5 187.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M671.5 187.5C672.605 187.5 673.5 186.605 673.5 185.5C673.5 184.395 672.605 183.5 671.5 183.5C670.395 183.5 669.5 184.395 669.5 185.5C669.5 186.605 670.395 187.5 671.5 187.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M720.5 187.5C721.605 187.5 722.5 186.605 722.5 185.5C722.5 184.395 721.605 183.5 720.5 183.5C719.395 183.5 718.5 184.395 718.5 185.5C718.5 186.605 719.395 187.5 720.5 187.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M769.5 187.5C770.605 187.5 771.5 186.605 771.5 185.5C771.5 184.395 770.605 183.5 769.5 183.5C768.395 183.5 767.5 184.395 767.5 185.5C767.5 186.605 768.395 187.5 769.5 187.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M818.5 187.5C819.605 187.5 820.5 186.605 820.5 185.5C820.5 184.395 819.605 183.5 818.5 183.5C817.395 183.5 816.5 184.395 816.5 185.5C816.5 186.605 817.395 187.5 818.5 187.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M867.5 187.5C868.605 187.5 869.5 186.605 869.5 185.5C869.5 184.395 868.605 183.5 867.5 183.5C866.395 183.5 865.5 184.395 865.5 185.5C865.5 186.605 866.395 187.5 867.5 187.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M916.5 187.5C917.605 187.5 918.5 186.605 918.5 185.5C918.5 184.395 917.605 183.5 916.5 183.5C915.395 183.5 914.5 184.395 914.5 185.5C914.5 186.605 915.395 187.5 916.5 187.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M965.5 187.5C966.605 187.5 967.5 186.605 967.5 185.5C967.5 184.395 966.605 183.5 965.5 183.5C964.395 183.5 963.5 184.395 963.5 185.5C963.5 186.605 964.395 187.5 965.5 187.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1014.5 187.5C1015.6 187.5 1016.5 186.605 1016.5 185.5C1016.5 184.395 1015.6 183.5 1014.5 183.5C1013.4 183.5 1012.5 184.395 1012.5 185.5C1012.5 186.605 1013.4 187.5 1014.5 187.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1063.5 187.5C1064.6 187.5 1065.5 186.605 1065.5 185.5C1065.5 184.395 1064.6 183.5 1063.5 183.5C1062.4 183.5 1061.5 184.395 1061.5 185.5C1061.5 186.605 1062.4 187.5 1063.5 187.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1112.5 187.5C1113.6 187.5 1114.5 186.605 1114.5 185.5C1114.5 184.395 1113.6 183.5 1112.5 183.5C1111.4 183.5 1110.5 184.395 1110.5 185.5C1110.5 186.605 1111.4 187.5 1112.5 187.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1161.5 187.5C1162.6 187.5 1163.5 186.605 1163.5 185.5C1163.5 184.395 1162.6 183.5 1161.5 183.5C1160.4 183.5 1159.5 184.395 1159.5 185.5C1159.5 186.605 1160.4 187.5 1161.5 187.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1210.5 187.5C1211.6 187.5 1212.5 186.605 1212.5 185.5C1212.5 184.395 1211.6 183.5 1210.5 183.5C1209.4 183.5 1208.5 184.395 1208.5 185.5C1208.5 186.605 1209.4 187.5 1210.5 187.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1259.5 187.5C1260.6 187.5 1261.5 186.605 1261.5 185.5C1261.5 184.395 1260.6 183.5 1259.5 183.5C1258.4 183.5 1257.5 184.395 1257.5 185.5C1257.5 186.605 1258.4 187.5 1259.5 187.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1308.5 187.5C1309.6 187.5 1310.5 186.605 1310.5 185.5C1310.5 184.395 1309.6 183.5 1308.5 183.5C1307.4 183.5 1306.5 184.395 1306.5 185.5C1306.5 186.605 1307.4 187.5 1308.5 187.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1357.5 187.5C1358.6 187.5 1359.5 186.605 1359.5 185.5C1359.5 184.395 1358.6 183.5 1357.5 183.5C1356.4 183.5 1355.5 184.395 1355.5 185.5C1355.5 186.605 1356.4 187.5 1357.5 187.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1406.5 187.5C1407.6 187.5 1408.5 186.605 1408.5 185.5C1408.5 184.395 1407.6 183.5 1406.5 183.5C1405.4 183.5 1404.5 184.395 1404.5 185.5C1404.5 186.605 1405.4 187.5 1406.5 187.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.5 236.5C35.6046 236.5 36.5 235.605 36.5 234.5C36.5 233.395 35.6046 232.5 34.5 232.5C33.3954 232.5 32.5 233.395 32.5 234.5C32.5 235.605 33.3954 236.5 34.5 236.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.5 236.5C84.6046 236.5 85.5 235.605 85.5 234.5C85.5 233.395 84.6046 232.5 83.5 232.5C82.3954 232.5 81.5 233.395 81.5 234.5C81.5 235.605 82.3954 236.5 83.5 236.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132.5 236.5C133.605 236.5 134.5 235.605 134.5 234.5C134.5 233.395 133.605 232.5 132.5 232.5C131.395 232.5 130.5 233.395 130.5 234.5C130.5 235.605 131.395 236.5 132.5 236.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M181.5 236.5C182.605 236.5 183.5 235.605 183.5 234.5C183.5 233.395 182.605 232.5 181.5 232.5C180.395 232.5 179.5 233.395 179.5 234.5C179.5 235.605 180.395 236.5 181.5 236.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M230.5 236.5C231.605 236.5 232.5 235.605 232.5 234.5C232.5 233.395 231.605 232.5 230.5 232.5C229.395 232.5 228.5 233.395 228.5 234.5C228.5 235.605 229.395 236.5 230.5 236.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M279.5 236.5C280.605 236.5 281.5 235.605 281.5 234.5C281.5 233.395 280.605 232.5 279.5 232.5C278.395 232.5 277.5 233.395 277.5 234.5C277.5 235.605 278.395 236.5 279.5 236.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M328.5 236.5C329.605 236.5 330.5 235.605 330.5 234.5C330.5 233.395 329.605 232.5 328.5 232.5C327.395 232.5 326.5 233.395 326.5 234.5C326.5 235.605 327.395 236.5 328.5 236.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M377.5 236.5C378.605 236.5 379.5 235.605 379.5 234.5C379.5 233.395 378.605 232.5 377.5 232.5C376.395 232.5 375.5 233.395 375.5 234.5C375.5 235.605 376.395 236.5 377.5 236.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M426.5 236.5C427.605 236.5 428.5 235.605 428.5 234.5C428.5 233.395 427.605 232.5 426.5 232.5C425.395 232.5 424.5 233.395 424.5 234.5C424.5 235.605 425.395 236.5 426.5 236.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M475.5 236.5C476.605 236.5 477.5 235.605 477.5 234.5C477.5 233.395 476.605 232.5 475.5 232.5C474.395 232.5 473.5 233.395 473.5 234.5C473.5 235.605 474.395 236.5 475.5 236.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M524.5 236.5C525.605 236.5 526.5 235.605 526.5 234.5C526.5 233.395 525.605 232.5 524.5 232.5C523.395 232.5 522.5 233.395 522.5 234.5C522.5 235.605 523.395 236.5 524.5 236.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M573.5 236.5C574.605 236.5 575.5 235.605 575.5 234.5C575.5 233.395 574.605 232.5 573.5 232.5C572.395 232.5 571.5 233.395 571.5 234.5C571.5 235.605 572.395 236.5 573.5 236.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M622.5 236.5C623.605 236.5 624.5 235.605 624.5 234.5C624.5 233.395 623.605 232.5 622.5 232.5C621.395 232.5 620.5 233.395 620.5 234.5C620.5 235.605 621.395 236.5 622.5 236.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M671.5 236.5C672.605 236.5 673.5 235.605 673.5 234.5C673.5 233.395 672.605 232.5 671.5 232.5C670.395 232.5 669.5 233.395 669.5 234.5C669.5 235.605 670.395 236.5 671.5 236.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M720.5 236.5C721.605 236.5 722.5 235.605 722.5 234.5C722.5 233.395 721.605 232.5 720.5 232.5C719.395 232.5 718.5 233.395 718.5 234.5C718.5 235.605 719.395 236.5 720.5 236.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M769.5 236.5C770.605 236.5 771.5 235.605 771.5 234.5C771.5 233.395 770.605 232.5 769.5 232.5C768.395 232.5 767.5 233.395 767.5 234.5C767.5 235.605 768.395 236.5 769.5 236.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M818.5 236.5C819.605 236.5 820.5 235.605 820.5 234.5C820.5 233.395 819.605 232.5 818.5 232.5C817.395 232.5 816.5 233.395 816.5 234.5C816.5 235.605 817.395 236.5 818.5 236.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M867.5 236.5C868.605 236.5 869.5 235.605 869.5 234.5C869.5 233.395 868.605 232.5 867.5 232.5C866.395 232.5 865.5 233.395 865.5 234.5C865.5 235.605 866.395 236.5 867.5 236.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M916.5 236.5C917.605 236.5 918.5 235.605 918.5 234.5C918.5 233.395 917.605 232.5 916.5 232.5C915.395 232.5 914.5 233.395 914.5 234.5C914.5 235.605 915.395 236.5 916.5 236.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M965.5 236.5C966.605 236.5 967.5 235.605 967.5 234.5C967.5 233.395 966.605 232.5 965.5 232.5C964.395 232.5 963.5 233.395 963.5 234.5C963.5 235.605 964.395 236.5 965.5 236.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1014.5 236.5C1015.6 236.5 1016.5 235.605 1016.5 234.5C1016.5 233.395 1015.6 232.5 1014.5 232.5C1013.4 232.5 1012.5 233.395 1012.5 234.5C1012.5 235.605 1013.4 236.5 1014.5 236.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1063.5 236.5C1064.6 236.5 1065.5 235.605 1065.5 234.5C1065.5 233.395 1064.6 232.5 1063.5 232.5C1062.4 232.5 1061.5 233.395 1061.5 234.5C1061.5 235.605 1062.4 236.5 1063.5 236.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1112.5 236.5C1113.6 236.5 1114.5 235.605 1114.5 234.5C1114.5 233.395 1113.6 232.5 1112.5 232.5C1111.4 232.5 1110.5 233.395 1110.5 234.5C1110.5 235.605 1111.4 236.5 1112.5 236.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1161.5 236.5C1162.6 236.5 1163.5 235.605 1163.5 234.5C1163.5 233.395 1162.6 232.5 1161.5 232.5C1160.4 232.5 1159.5 233.395 1159.5 234.5C1159.5 235.605 1160.4 236.5 1161.5 236.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1210.5 236.5C1211.6 236.5 1212.5 235.605 1212.5 234.5C1212.5 233.395 1211.6 232.5 1210.5 232.5C1209.4 232.5 1208.5 233.395 1208.5 234.5C1208.5 235.605 1209.4 236.5 1210.5 236.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1259.5 236.5C1260.6 236.5 1261.5 235.605 1261.5 234.5C1261.5 233.395 1260.6 232.5 1259.5 232.5C1258.4 232.5 1257.5 233.395 1257.5 234.5C1257.5 235.605 1258.4 236.5 1259.5 236.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1308.5 236.5C1309.6 236.5 1310.5 235.605 1310.5 234.5C1310.5 233.395 1309.6 232.5 1308.5 232.5C1307.4 232.5 1306.5 233.395 1306.5 234.5C1306.5 235.605 1307.4 236.5 1308.5 236.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1357.5 236.5C1358.6 236.5 1359.5 235.605 1359.5 234.5C1359.5 233.395 1358.6 232.5 1357.5 232.5C1356.4 232.5 1355.5 233.395 1355.5 234.5C1355.5 235.605 1356.4 236.5 1357.5 236.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1406.5 236.5C1407.6 236.5 1408.5 235.605 1408.5 234.5C1408.5 233.395 1407.6 232.5 1406.5 232.5C1405.4 232.5 1404.5 233.395 1404.5 234.5C1404.5 235.605 1405.4 236.5 1406.5 236.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.5 285.5C35.6046 285.5 36.5 284.605 36.5 283.5C36.5 282.395 35.6046 281.5 34.5 281.5C33.3954 281.5 32.5 282.395 32.5 283.5C32.5 284.605 33.3954 285.5 34.5 285.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.5 285.5C84.6046 285.5 85.5 284.605 85.5 283.5C85.5 282.395 84.6046 281.5 83.5 281.5C82.3954 281.5 81.5 282.395 81.5 283.5C81.5 284.605 82.3954 285.5 83.5 285.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132.5 285.5C133.605 285.5 134.5 284.605 134.5 283.5C134.5 282.395 133.605 281.5 132.5 281.5C131.395 281.5 130.5 282.395 130.5 283.5C130.5 284.605 131.395 285.5 132.5 285.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M181.5 285.5C182.605 285.5 183.5 284.605 183.5 283.5C183.5 282.395 182.605 281.5 181.5 281.5C180.395 281.5 179.5 282.395 179.5 283.5C179.5 284.605 180.395 285.5 181.5 285.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M230.5 285.5C231.605 285.5 232.5 284.605 232.5 283.5C232.5 282.395 231.605 281.5 230.5 281.5C229.395 281.5 228.5 282.395 228.5 283.5C228.5 284.605 229.395 285.5 230.5 285.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M279.5 285.5C280.605 285.5 281.5 284.605 281.5 283.5C281.5 282.395 280.605 281.5 279.5 281.5C278.395 281.5 277.5 282.395 277.5 283.5C277.5 284.605 278.395 285.5 279.5 285.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M328.5 285.5C329.605 285.5 330.5 284.605 330.5 283.5C330.5 282.395 329.605 281.5 328.5 281.5C327.395 281.5 326.5 282.395 326.5 283.5C326.5 284.605 327.395 285.5 328.5 285.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M377.5 285.5C378.605 285.5 379.5 284.605 379.5 283.5C379.5 282.395 378.605 281.5 377.5 281.5C376.395 281.5 375.5 282.395 375.5 283.5C375.5 284.605 376.395 285.5 377.5 285.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M426.5 285.5C427.605 285.5 428.5 284.605 428.5 283.5C428.5 282.395 427.605 281.5 426.5 281.5C425.395 281.5 424.5 282.395 424.5 283.5C424.5 284.605 425.395 285.5 426.5 285.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M475.5 285.5C476.605 285.5 477.5 284.605 477.5 283.5C477.5 282.395 476.605 281.5 475.5 281.5C474.395 281.5 473.5 282.395 473.5 283.5C473.5 284.605 474.395 285.5 475.5 285.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M524.5 285.5C525.605 285.5 526.5 284.605 526.5 283.5C526.5 282.395 525.605 281.5 524.5 281.5C523.395 281.5 522.5 282.395 522.5 283.5C522.5 284.605 523.395 285.5 524.5 285.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M573.5 285.5C574.605 285.5 575.5 284.605 575.5 283.5C575.5 282.395 574.605 281.5 573.5 281.5C572.395 281.5 571.5 282.395 571.5 283.5C571.5 284.605 572.395 285.5 573.5 285.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M622.5 285.5C623.605 285.5 624.5 284.605 624.5 283.5C624.5 282.395 623.605 281.5 622.5 281.5C621.395 281.5 620.5 282.395 620.5 283.5C620.5 284.605 621.395 285.5 622.5 285.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M671.5 285.5C672.605 285.5 673.5 284.605 673.5 283.5C673.5 282.395 672.605 281.5 671.5 281.5C670.395 281.5 669.5 282.395 669.5 283.5C669.5 284.605 670.395 285.5 671.5 285.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M720.5 285.5C721.605 285.5 722.5 284.605 722.5 283.5C722.5 282.395 721.605 281.5 720.5 281.5C719.395 281.5 718.5 282.395 718.5 283.5C718.5 284.605 719.395 285.5 720.5 285.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M769.5 285.5C770.605 285.5 771.5 284.605 771.5 283.5C771.5 282.395 770.605 281.5 769.5 281.5C768.395 281.5 767.5 282.395 767.5 283.5C767.5 284.605 768.395 285.5 769.5 285.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M818.5 285.5C819.605 285.5 820.5 284.605 820.5 283.5C820.5 282.395 819.605 281.5 818.5 281.5C817.395 281.5 816.5 282.395 816.5 283.5C816.5 284.605 817.395 285.5 818.5 285.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M867.5 285.5C868.605 285.5 869.5 284.605 869.5 283.5C869.5 282.395 868.605 281.5 867.5 281.5C866.395 281.5 865.5 282.395 865.5 283.5C865.5 284.605 866.395 285.5 867.5 285.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M916.5 285.5C917.605 285.5 918.5 284.605 918.5 283.5C918.5 282.395 917.605 281.5 916.5 281.5C915.395 281.5 914.5 282.395 914.5 283.5C914.5 284.605 915.395 285.5 916.5 285.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M965.5 285.5C966.605 285.5 967.5 284.605 967.5 283.5C967.5 282.395 966.605 281.5 965.5 281.5C964.395 281.5 963.5 282.395 963.5 283.5C963.5 284.605 964.395 285.5 965.5 285.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1014.5 285.5C1015.6 285.5 1016.5 284.605 1016.5 283.5C1016.5 282.395 1015.6 281.5 1014.5 281.5C1013.4 281.5 1012.5 282.395 1012.5 283.5C1012.5 284.605 1013.4 285.5 1014.5 285.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1063.5 285.5C1064.6 285.5 1065.5 284.605 1065.5 283.5C1065.5 282.395 1064.6 281.5 1063.5 281.5C1062.4 281.5 1061.5 282.395 1061.5 283.5C1061.5 284.605 1062.4 285.5 1063.5 285.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1112.5 285.5C1113.6 285.5 1114.5 284.605 1114.5 283.5C1114.5 282.395 1113.6 281.5 1112.5 281.5C1111.4 281.5 1110.5 282.395 1110.5 283.5C1110.5 284.605 1111.4 285.5 1112.5 285.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1161.5 285.5C1162.6 285.5 1163.5 284.605 1163.5 283.5C1163.5 282.395 1162.6 281.5 1161.5 281.5C1160.4 281.5 1159.5 282.395 1159.5 283.5C1159.5 284.605 1160.4 285.5 1161.5 285.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1210.5 285.5C1211.6 285.5 1212.5 284.605 1212.5 283.5C1212.5 282.395 1211.6 281.5 1210.5 281.5C1209.4 281.5 1208.5 282.395 1208.5 283.5C1208.5 284.605 1209.4 285.5 1210.5 285.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1259.5 285.5C1260.6 285.5 1261.5 284.605 1261.5 283.5C1261.5 282.395 1260.6 281.5 1259.5 281.5C1258.4 281.5 1257.5 282.395 1257.5 283.5C1257.5 284.605 1258.4 285.5 1259.5 285.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1308.5 285.5C1309.6 285.5 1310.5 284.605 1310.5 283.5C1310.5 282.395 1309.6 281.5 1308.5 281.5C1307.4 281.5 1306.5 282.395 1306.5 283.5C1306.5 284.605 1307.4 285.5 1308.5 285.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1357.5 285.5C1358.6 285.5 1359.5 284.605 1359.5 283.5C1359.5 282.395 1358.6 281.5 1357.5 281.5C1356.4 281.5 1355.5 282.395 1355.5 283.5C1355.5 284.605 1356.4 285.5 1357.5 285.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1406.5 285.5C1407.6 285.5 1408.5 284.605 1408.5 283.5C1408.5 282.395 1407.6 281.5 1406.5 281.5C1405.4 281.5 1404.5 282.395 1404.5 283.5C1404.5 284.605 1405.4 285.5 1406.5 285.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.5 334.5C35.6046 334.5 36.5 333.605 36.5 332.5C36.5 331.395 35.6046 330.5 34.5 330.5C33.3954 330.5 32.5 331.395 32.5 332.5C32.5 333.605 33.3954 334.5 34.5 334.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.5 334.5C84.6046 334.5 85.5 333.605 85.5 332.5C85.5 331.395 84.6046 330.5 83.5 330.5C82.3954 330.5 81.5 331.395 81.5 332.5C81.5 333.605 82.3954 334.5 83.5 334.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132.5 334.5C133.605 334.5 134.5 333.605 134.5 332.5C134.5 331.395 133.605 330.5 132.5 330.5C131.395 330.5 130.5 331.395 130.5 332.5C130.5 333.605 131.395 334.5 132.5 334.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M181.5 334.5C182.605 334.5 183.5 333.605 183.5 332.5C183.5 331.395 182.605 330.5 181.5 330.5C180.395 330.5 179.5 331.395 179.5 332.5C179.5 333.605 180.395 334.5 181.5 334.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M230.5 334.5C231.605 334.5 232.5 333.605 232.5 332.5C232.5 331.395 231.605 330.5 230.5 330.5C229.395 330.5 228.5 331.395 228.5 332.5C228.5 333.605 229.395 334.5 230.5 334.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M279.5 334.5C280.605 334.5 281.5 333.605 281.5 332.5C281.5 331.395 280.605 330.5 279.5 330.5C278.395 330.5 277.5 331.395 277.5 332.5C277.5 333.605 278.395 334.5 279.5 334.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M328.5 334.5C329.605 334.5 330.5 333.605 330.5 332.5C330.5 331.395 329.605 330.5 328.5 330.5C327.395 330.5 326.5 331.395 326.5 332.5C326.5 333.605 327.395 334.5 328.5 334.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M377.5 334.5C378.605 334.5 379.5 333.605 379.5 332.5C379.5 331.395 378.605 330.5 377.5 330.5C376.395 330.5 375.5 331.395 375.5 332.5C375.5 333.605 376.395 334.5 377.5 334.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M426.5 334.5C427.605 334.5 428.5 333.605 428.5 332.5C428.5 331.395 427.605 330.5 426.5 330.5C425.395 330.5 424.5 331.395 424.5 332.5C424.5 333.605 425.395 334.5 426.5 334.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M475.5 334.5C476.605 334.5 477.5 333.605 477.5 332.5C477.5 331.395 476.605 330.5 475.5 330.5C474.395 330.5 473.5 331.395 473.5 332.5C473.5 333.605 474.395 334.5 475.5 334.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M524.5 334.5C525.605 334.5 526.5 333.605 526.5 332.5C526.5 331.395 525.605 330.5 524.5 330.5C523.395 330.5 522.5 331.395 522.5 332.5C522.5 333.605 523.395 334.5 524.5 334.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M573.5 334.5C574.605 334.5 575.5 333.605 575.5 332.5C575.5 331.395 574.605 330.5 573.5 330.5C572.395 330.5 571.5 331.395 571.5 332.5C571.5 333.605 572.395 334.5 573.5 334.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M622.5 334.5C623.605 334.5 624.5 333.605 624.5 332.5C624.5 331.395 623.605 330.5 622.5 330.5C621.395 330.5 620.5 331.395 620.5 332.5C620.5 333.605 621.395 334.5 622.5 334.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M671.5 334.5C672.605 334.5 673.5 333.605 673.5 332.5C673.5 331.395 672.605 330.5 671.5 330.5C670.395 330.5 669.5 331.395 669.5 332.5C669.5 333.605 670.395 334.5 671.5 334.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M720.5 334.5C721.605 334.5 722.5 333.605 722.5 332.5C722.5 331.395 721.605 330.5 720.5 330.5C719.395 330.5 718.5 331.395 718.5 332.5C718.5 333.605 719.395 334.5 720.5 334.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M769.5 334.5C770.605 334.5 771.5 333.605 771.5 332.5C771.5 331.395 770.605 330.5 769.5 330.5C768.395 330.5 767.5 331.395 767.5 332.5C767.5 333.605 768.395 334.5 769.5 334.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M818.5 334.5C819.605 334.5 820.5 333.605 820.5 332.5C820.5 331.395 819.605 330.5 818.5 330.5C817.395 330.5 816.5 331.395 816.5 332.5C816.5 333.605 817.395 334.5 818.5 334.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M867.5 334.5C868.605 334.5 869.5 333.605 869.5 332.5C869.5 331.395 868.605 330.5 867.5 330.5C866.395 330.5 865.5 331.395 865.5 332.5C865.5 333.605 866.395 334.5 867.5 334.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M916.5 334.5C917.605 334.5 918.5 333.605 918.5 332.5C918.5 331.395 917.605 330.5 916.5 330.5C915.395 330.5 914.5 331.395 914.5 332.5C914.5 333.605 915.395 334.5 916.5 334.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M965.5 334.5C966.605 334.5 967.5 333.605 967.5 332.5C967.5 331.395 966.605 330.5 965.5 330.5C964.395 330.5 963.5 331.395 963.5 332.5C963.5 333.605 964.395 334.5 965.5 334.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1014.5 334.5C1015.6 334.5 1016.5 333.605 1016.5 332.5C1016.5 331.395 1015.6 330.5 1014.5 330.5C1013.4 330.5 1012.5 331.395 1012.5 332.5C1012.5 333.605 1013.4 334.5 1014.5 334.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1063.5 334.5C1064.6 334.5 1065.5 333.605 1065.5 332.5C1065.5 331.395 1064.6 330.5 1063.5 330.5C1062.4 330.5 1061.5 331.395 1061.5 332.5C1061.5 333.605 1062.4 334.5 1063.5 334.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1112.5 334.5C1113.6 334.5 1114.5 333.605 1114.5 332.5C1114.5 331.395 1113.6 330.5 1112.5 330.5C1111.4 330.5 1110.5 331.395 1110.5 332.5C1110.5 333.605 1111.4 334.5 1112.5 334.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1161.5 334.5C1162.6 334.5 1163.5 333.605 1163.5 332.5C1163.5 331.395 1162.6 330.5 1161.5 330.5C1160.4 330.5 1159.5 331.395 1159.5 332.5C1159.5 333.605 1160.4 334.5 1161.5 334.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1210.5 334.5C1211.6 334.5 1212.5 333.605 1212.5 332.5C1212.5 331.395 1211.6 330.5 1210.5 330.5C1209.4 330.5 1208.5 331.395 1208.5 332.5C1208.5 333.605 1209.4 334.5 1210.5 334.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1259.5 334.5C1260.6 334.5 1261.5 333.605 1261.5 332.5C1261.5 331.395 1260.6 330.5 1259.5 330.5C1258.4 330.5 1257.5 331.395 1257.5 332.5C1257.5 333.605 1258.4 334.5 1259.5 334.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1308.5 334.5C1309.6 334.5 1310.5 333.605 1310.5 332.5C1310.5 331.395 1309.6 330.5 1308.5 330.5C1307.4 330.5 1306.5 331.395 1306.5 332.5C1306.5 333.605 1307.4 334.5 1308.5 334.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1357.5 334.5C1358.6 334.5 1359.5 333.605 1359.5 332.5C1359.5 331.395 1358.6 330.5 1357.5 330.5C1356.4 330.5 1355.5 331.395 1355.5 332.5C1355.5 333.605 1356.4 334.5 1357.5 334.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1406.5 334.5C1407.6 334.5 1408.5 333.605 1408.5 332.5C1408.5 331.395 1407.6 330.5 1406.5 330.5C1405.4 330.5 1404.5 331.395 1404.5 332.5C1404.5 333.605 1405.4 334.5 1406.5 334.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.5 383.5C35.6046 383.5 36.5 382.605 36.5 381.5C36.5 380.395 35.6046 379.5 34.5 379.5C33.3954 379.5 32.5 380.395 32.5 381.5C32.5 382.605 33.3954 383.5 34.5 383.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.5 383.5C84.6046 383.5 85.5 382.605 85.5 381.5C85.5 380.395 84.6046 379.5 83.5 379.5C82.3954 379.5 81.5 380.395 81.5 381.5C81.5 382.605 82.3954 383.5 83.5 383.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132.5 383.5C133.605 383.5 134.5 382.605 134.5 381.5C134.5 380.395 133.605 379.5 132.5 379.5C131.395 379.5 130.5 380.395 130.5 381.5C130.5 382.605 131.395 383.5 132.5 383.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M181.5 383.5C182.605 383.5 183.5 382.605 183.5 381.5C183.5 380.395 182.605 379.5 181.5 379.5C180.395 379.5 179.5 380.395 179.5 381.5C179.5 382.605 180.395 383.5 181.5 383.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M230.5 383.5C231.605 383.5 232.5 382.605 232.5 381.5C232.5 380.395 231.605 379.5 230.5 379.5C229.395 379.5 228.5 380.395 228.5 381.5C228.5 382.605 229.395 383.5 230.5 383.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M279.5 383.5C280.605 383.5 281.5 382.605 281.5 381.5C281.5 380.395 280.605 379.5 279.5 379.5C278.395 379.5 277.5 380.395 277.5 381.5C277.5 382.605 278.395 383.5 279.5 383.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M328.5 383.5C329.605 383.5 330.5 382.605 330.5 381.5C330.5 380.395 329.605 379.5 328.5 379.5C327.395 379.5 326.5 380.395 326.5 381.5C326.5 382.605 327.395 383.5 328.5 383.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M377.5 383.5C378.605 383.5 379.5 382.605 379.5 381.5C379.5 380.395 378.605 379.5 377.5 379.5C376.395 379.5 375.5 380.395 375.5 381.5C375.5 382.605 376.395 383.5 377.5 383.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M426.5 383.5C427.605 383.5 428.5 382.605 428.5 381.5C428.5 380.395 427.605 379.5 426.5 379.5C425.395 379.5 424.5 380.395 424.5 381.5C424.5 382.605 425.395 383.5 426.5 383.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M475.5 383.5C476.605 383.5 477.5 382.605 477.5 381.5C477.5 380.395 476.605 379.5 475.5 379.5C474.395 379.5 473.5 380.395 473.5 381.5C473.5 382.605 474.395 383.5 475.5 383.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M524.5 383.5C525.605 383.5 526.5 382.605 526.5 381.5C526.5 380.395 525.605 379.5 524.5 379.5C523.395 379.5 522.5 380.395 522.5 381.5C522.5 382.605 523.395 383.5 524.5 383.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M573.5 383.5C574.605 383.5 575.5 382.605 575.5 381.5C575.5 380.395 574.605 379.5 573.5 379.5C572.395 379.5 571.5 380.395 571.5 381.5C571.5 382.605 572.395 383.5 573.5 383.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M622.5 383.5C623.605 383.5 624.5 382.605 624.5 381.5C624.5 380.395 623.605 379.5 622.5 379.5C621.395 379.5 620.5 380.395 620.5 381.5C620.5 382.605 621.395 383.5 622.5 383.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M671.5 383.5C672.605 383.5 673.5 382.605 673.5 381.5C673.5 380.395 672.605 379.5 671.5 379.5C670.395 379.5 669.5 380.395 669.5 381.5C669.5 382.605 670.395 383.5 671.5 383.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M720.5 383.5C721.605 383.5 722.5 382.605 722.5 381.5C722.5 380.395 721.605 379.5 720.5 379.5C719.395 379.5 718.5 380.395 718.5 381.5C718.5 382.605 719.395 383.5 720.5 383.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M769.5 383.5C770.605 383.5 771.5 382.605 771.5 381.5C771.5 380.395 770.605 379.5 769.5 379.5C768.395 379.5 767.5 380.395 767.5 381.5C767.5 382.605 768.395 383.5 769.5 383.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M818.5 383.5C819.605 383.5 820.5 382.605 820.5 381.5C820.5 380.395 819.605 379.5 818.5 379.5C817.395 379.5 816.5 380.395 816.5 381.5C816.5 382.605 817.395 383.5 818.5 383.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M867.5 383.5C868.605 383.5 869.5 382.605 869.5 381.5C869.5 380.395 868.605 379.5 867.5 379.5C866.395 379.5 865.5 380.395 865.5 381.5C865.5 382.605 866.395 383.5 867.5 383.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M916.5 383.5C917.605 383.5 918.5 382.605 918.5 381.5C918.5 380.395 917.605 379.5 916.5 379.5C915.395 379.5 914.5 380.395 914.5 381.5C914.5 382.605 915.395 383.5 916.5 383.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M965.5 383.5C966.605 383.5 967.5 382.605 967.5 381.5C967.5 380.395 966.605 379.5 965.5 379.5C964.395 379.5 963.5 380.395 963.5 381.5C963.5 382.605 964.395 383.5 965.5 383.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1014.5 383.5C1015.6 383.5 1016.5 382.605 1016.5 381.5C1016.5 380.395 1015.6 379.5 1014.5 379.5C1013.4 379.5 1012.5 380.395 1012.5 381.5C1012.5 382.605 1013.4 383.5 1014.5 383.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1063.5 383.5C1064.6 383.5 1065.5 382.605 1065.5 381.5C1065.5 380.395 1064.6 379.5 1063.5 379.5C1062.4 379.5 1061.5 380.395 1061.5 381.5C1061.5 382.605 1062.4 383.5 1063.5 383.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1112.5 383.5C1113.6 383.5 1114.5 382.605 1114.5 381.5C1114.5 380.395 1113.6 379.5 1112.5 379.5C1111.4 379.5 1110.5 380.395 1110.5 381.5C1110.5 382.605 1111.4 383.5 1112.5 383.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1161.5 383.5C1162.6 383.5 1163.5 382.605 1163.5 381.5C1163.5 380.395 1162.6 379.5 1161.5 379.5C1160.4 379.5 1159.5 380.395 1159.5 381.5C1159.5 382.605 1160.4 383.5 1161.5 383.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1210.5 383.5C1211.6 383.5 1212.5 382.605 1212.5 381.5C1212.5 380.395 1211.6 379.5 1210.5 379.5C1209.4 379.5 1208.5 380.395 1208.5 381.5C1208.5 382.605 1209.4 383.5 1210.5 383.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1259.5 383.5C1260.6 383.5 1261.5 382.605 1261.5 381.5C1261.5 380.395 1260.6 379.5 1259.5 379.5C1258.4 379.5 1257.5 380.395 1257.5 381.5C1257.5 382.605 1258.4 383.5 1259.5 383.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1308.5 383.5C1309.6 383.5 1310.5 382.605 1310.5 381.5C1310.5 380.395 1309.6 379.5 1308.5 379.5C1307.4 379.5 1306.5 380.395 1306.5 381.5C1306.5 382.605 1307.4 383.5 1308.5 383.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1357.5 383.5C1358.6 383.5 1359.5 382.605 1359.5 381.5C1359.5 380.395 1358.6 379.5 1357.5 379.5C1356.4 379.5 1355.5 380.395 1355.5 381.5C1355.5 382.605 1356.4 383.5 1357.5 383.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1406.5 383.5C1407.6 383.5 1408.5 382.605 1408.5 381.5C1408.5 380.395 1407.6 379.5 1406.5 379.5C1405.4 379.5 1404.5 380.395 1404.5 381.5C1404.5 382.605 1405.4 383.5 1406.5 383.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.5 432.5C35.6046 432.5 36.5 431.605 36.5 430.5C36.5 429.395 35.6046 428.5 34.5 428.5C33.3954 428.5 32.5 429.395 32.5 430.5C32.5 431.605 33.3954 432.5 34.5 432.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.5 432.5C84.6046 432.5 85.5 431.605 85.5 430.5C85.5 429.395 84.6046 428.5 83.5 428.5C82.3954 428.5 81.5 429.395 81.5 430.5C81.5 431.605 82.3954 432.5 83.5 432.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132.5 432.5C133.605 432.5 134.5 431.605 134.5 430.5C134.5 429.395 133.605 428.5 132.5 428.5C131.395 428.5 130.5 429.395 130.5 430.5C130.5 431.605 131.395 432.5 132.5 432.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M181.5 432.5C182.605 432.5 183.5 431.605 183.5 430.5C183.5 429.395 182.605 428.5 181.5 428.5C180.395 428.5 179.5 429.395 179.5 430.5C179.5 431.605 180.395 432.5 181.5 432.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M230.5 432.5C231.605 432.5 232.5 431.605 232.5 430.5C232.5 429.395 231.605 428.5 230.5 428.5C229.395 428.5 228.5 429.395 228.5 430.5C228.5 431.605 229.395 432.5 230.5 432.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M279.5 432.5C280.605 432.5 281.5 431.605 281.5 430.5C281.5 429.395 280.605 428.5 279.5 428.5C278.395 428.5 277.5 429.395 277.5 430.5C277.5 431.605 278.395 432.5 279.5 432.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M328.5 432.5C329.605 432.5 330.5 431.605 330.5 430.5C330.5 429.395 329.605 428.5 328.5 428.5C327.395 428.5 326.5 429.395 326.5 430.5C326.5 431.605 327.395 432.5 328.5 432.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M377.5 432.5C378.605 432.5 379.5 431.605 379.5 430.5C379.5 429.395 378.605 428.5 377.5 428.5C376.395 428.5 375.5 429.395 375.5 430.5C375.5 431.605 376.395 432.5 377.5 432.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M426.5 432.5C427.605 432.5 428.5 431.605 428.5 430.5C428.5 429.395 427.605 428.5 426.5 428.5C425.395 428.5 424.5 429.395 424.5 430.5C424.5 431.605 425.395 432.5 426.5 432.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M475.5 432.5C476.605 432.5 477.5 431.605 477.5 430.5C477.5 429.395 476.605 428.5 475.5 428.5C474.395 428.5 473.5 429.395 473.5 430.5C473.5 431.605 474.395 432.5 475.5 432.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M524.5 432.5C525.605 432.5 526.5 431.605 526.5 430.5C526.5 429.395 525.605 428.5 524.5 428.5C523.395 428.5 522.5 429.395 522.5 430.5C522.5 431.605 523.395 432.5 524.5 432.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M573.5 432.5C574.605 432.5 575.5 431.605 575.5 430.5C575.5 429.395 574.605 428.5 573.5 428.5C572.395 428.5 571.5 429.395 571.5 430.5C571.5 431.605 572.395 432.5 573.5 432.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M622.5 432.5C623.605 432.5 624.5 431.605 624.5 430.5C624.5 429.395 623.605 428.5 622.5 428.5C621.395 428.5 620.5 429.395 620.5 430.5C620.5 431.605 621.395 432.5 622.5 432.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M671.5 432.5C672.605 432.5 673.5 431.605 673.5 430.5C673.5 429.395 672.605 428.5 671.5 428.5C670.395 428.5 669.5 429.395 669.5 430.5C669.5 431.605 670.395 432.5 671.5 432.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M720.5 432.5C721.605 432.5 722.5 431.605 722.5 430.5C722.5 429.395 721.605 428.5 720.5 428.5C719.395 428.5 718.5 429.395 718.5 430.5C718.5 431.605 719.395 432.5 720.5 432.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M769.5 432.5C770.605 432.5 771.5 431.605 771.5 430.5C771.5 429.395 770.605 428.5 769.5 428.5C768.395 428.5 767.5 429.395 767.5 430.5C767.5 431.605 768.395 432.5 769.5 432.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M818.5 432.5C819.605 432.5 820.5 431.605 820.5 430.5C820.5 429.395 819.605 428.5 818.5 428.5C817.395 428.5 816.5 429.395 816.5 430.5C816.5 431.605 817.395 432.5 818.5 432.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M867.5 432.5C868.605 432.5 869.5 431.605 869.5 430.5C869.5 429.395 868.605 428.5 867.5 428.5C866.395 428.5 865.5 429.395 865.5 430.5C865.5 431.605 866.395 432.5 867.5 432.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M916.5 432.5C917.605 432.5 918.5 431.605 918.5 430.5C918.5 429.395 917.605 428.5 916.5 428.5C915.395 428.5 914.5 429.395 914.5 430.5C914.5 431.605 915.395 432.5 916.5 432.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M965.5 432.5C966.605 432.5 967.5 431.605 967.5 430.5C967.5 429.395 966.605 428.5 965.5 428.5C964.395 428.5 963.5 429.395 963.5 430.5C963.5 431.605 964.395 432.5 965.5 432.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1014.5 432.5C1015.6 432.5 1016.5 431.605 1016.5 430.5C1016.5 429.395 1015.6 428.5 1014.5 428.5C1013.4 428.5 1012.5 429.395 1012.5 430.5C1012.5 431.605 1013.4 432.5 1014.5 432.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1063.5 432.5C1064.6 432.5 1065.5 431.605 1065.5 430.5C1065.5 429.395 1064.6 428.5 1063.5 428.5C1062.4 428.5 1061.5 429.395 1061.5 430.5C1061.5 431.605 1062.4 432.5 1063.5 432.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1112.5 432.5C1113.6 432.5 1114.5 431.605 1114.5 430.5C1114.5 429.395 1113.6 428.5 1112.5 428.5C1111.4 428.5 1110.5 429.395 1110.5 430.5C1110.5 431.605 1111.4 432.5 1112.5 432.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1161.5 432.5C1162.6 432.5 1163.5 431.605 1163.5 430.5C1163.5 429.395 1162.6 428.5 1161.5 428.5C1160.4 428.5 1159.5 429.395 1159.5 430.5C1159.5 431.605 1160.4 432.5 1161.5 432.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1210.5 432.5C1211.6 432.5 1212.5 431.605 1212.5 430.5C1212.5 429.395 1211.6 428.5 1210.5 428.5C1209.4 428.5 1208.5 429.395 1208.5 430.5C1208.5 431.605 1209.4 432.5 1210.5 432.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1259.5 432.5C1260.6 432.5 1261.5 431.605 1261.5 430.5C1261.5 429.395 1260.6 428.5 1259.5 428.5C1258.4 428.5 1257.5 429.395 1257.5 430.5C1257.5 431.605 1258.4 432.5 1259.5 432.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1308.5 432.5C1309.6 432.5 1310.5 431.605 1310.5 430.5C1310.5 429.395 1309.6 428.5 1308.5 428.5C1307.4 428.5 1306.5 429.395 1306.5 430.5C1306.5 431.605 1307.4 432.5 1308.5 432.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1357.5 432.5C1358.6 432.5 1359.5 431.605 1359.5 430.5C1359.5 429.395 1358.6 428.5 1357.5 428.5C1356.4 428.5 1355.5 429.395 1355.5 430.5C1355.5 431.605 1356.4 432.5 1357.5 432.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1406.5 432.5C1407.6 432.5 1408.5 431.605 1408.5 430.5C1408.5 429.395 1407.6 428.5 1406.5 428.5C1405.4 428.5 1404.5 429.395 1404.5 430.5C1404.5 431.605 1405.4 432.5 1406.5 432.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.5 481.5C35.6046 481.5 36.5 480.605 36.5 479.5C36.5 478.395 35.6046 477.5 34.5 477.5C33.3954 477.5 32.5 478.395 32.5 479.5C32.5 480.605 33.3954 481.5 34.5 481.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.5 481.5C84.6046 481.5 85.5 480.605 85.5 479.5C85.5 478.395 84.6046 477.5 83.5 477.5C82.3954 477.5 81.5 478.395 81.5 479.5C81.5 480.605 82.3954 481.5 83.5 481.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132.5 481.5C133.605 481.5 134.5 480.605 134.5 479.5C134.5 478.395 133.605 477.5 132.5 477.5C131.395 477.5 130.5 478.395 130.5 479.5C130.5 480.605 131.395 481.5 132.5 481.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M181.5 481.5C182.605 481.5 183.5 480.605 183.5 479.5C183.5 478.395 182.605 477.5 181.5 477.5C180.395 477.5 179.5 478.395 179.5 479.5C179.5 480.605 180.395 481.5 181.5 481.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M230.5 481.5C231.605 481.5 232.5 480.605 232.5 479.5C232.5 478.395 231.605 477.5 230.5 477.5C229.395 477.5 228.5 478.395 228.5 479.5C228.5 480.605 229.395 481.5 230.5 481.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M279.5 481.5C280.605 481.5 281.5 480.605 281.5 479.5C281.5 478.395 280.605 477.5 279.5 477.5C278.395 477.5 277.5 478.395 277.5 479.5C277.5 480.605 278.395 481.5 279.5 481.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M328.5 481.5C329.605 481.5 330.5 480.605 330.5 479.5C330.5 478.395 329.605 477.5 328.5 477.5C327.395 477.5 326.5 478.395 326.5 479.5C326.5 480.605 327.395 481.5 328.5 481.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M377.5 481.5C378.605 481.5 379.5 480.605 379.5 479.5C379.5 478.395 378.605 477.5 377.5 477.5C376.395 477.5 375.5 478.395 375.5 479.5C375.5 480.605 376.395 481.5 377.5 481.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M426.5 481.5C427.605 481.5 428.5 480.605 428.5 479.5C428.5 478.395 427.605 477.5 426.5 477.5C425.395 477.5 424.5 478.395 424.5 479.5C424.5 480.605 425.395 481.5 426.5 481.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M475.5 481.5C476.605 481.5 477.5 480.605 477.5 479.5C477.5 478.395 476.605 477.5 475.5 477.5C474.395 477.5 473.5 478.395 473.5 479.5C473.5 480.605 474.395 481.5 475.5 481.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M524.5 481.5C525.605 481.5 526.5 480.605 526.5 479.5C526.5 478.395 525.605 477.5 524.5 477.5C523.395 477.5 522.5 478.395 522.5 479.5C522.5 480.605 523.395 481.5 524.5 481.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M573.5 481.5C574.605 481.5 575.5 480.605 575.5 479.5C575.5 478.395 574.605 477.5 573.5 477.5C572.395 477.5 571.5 478.395 571.5 479.5C571.5 480.605 572.395 481.5 573.5 481.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M622.5 481.5C623.605 481.5 624.5 480.605 624.5 479.5C624.5 478.395 623.605 477.5 622.5 477.5C621.395 477.5 620.5 478.395 620.5 479.5C620.5 480.605 621.395 481.5 622.5 481.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M671.5 481.5C672.605 481.5 673.5 480.605 673.5 479.5C673.5 478.395 672.605 477.5 671.5 477.5C670.395 477.5 669.5 478.395 669.5 479.5C669.5 480.605 670.395 481.5 671.5 481.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M720.5 481.5C721.605 481.5 722.5 480.605 722.5 479.5C722.5 478.395 721.605 477.5 720.5 477.5C719.395 477.5 718.5 478.395 718.5 479.5C718.5 480.605 719.395 481.5 720.5 481.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M769.5 481.5C770.605 481.5 771.5 480.605 771.5 479.5C771.5 478.395 770.605 477.5 769.5 477.5C768.395 477.5 767.5 478.395 767.5 479.5C767.5 480.605 768.395 481.5 769.5 481.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M818.5 481.5C819.605 481.5 820.5 480.605 820.5 479.5C820.5 478.395 819.605 477.5 818.5 477.5C817.395 477.5 816.5 478.395 816.5 479.5C816.5 480.605 817.395 481.5 818.5 481.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M867.5 481.5C868.605 481.5 869.5 480.605 869.5 479.5C869.5 478.395 868.605 477.5 867.5 477.5C866.395 477.5 865.5 478.395 865.5 479.5C865.5 480.605 866.395 481.5 867.5 481.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M916.5 481.5C917.605 481.5 918.5 480.605 918.5 479.5C918.5 478.395 917.605 477.5 916.5 477.5C915.395 477.5 914.5 478.395 914.5 479.5C914.5 480.605 915.395 481.5 916.5 481.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M965.5 481.5C966.605 481.5 967.5 480.605 967.5 479.5C967.5 478.395 966.605 477.5 965.5 477.5C964.395 477.5 963.5 478.395 963.5 479.5C963.5 480.605 964.395 481.5 965.5 481.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1014.5 481.5C1015.6 481.5 1016.5 480.605 1016.5 479.5C1016.5 478.395 1015.6 477.5 1014.5 477.5C1013.4 477.5 1012.5 478.395 1012.5 479.5C1012.5 480.605 1013.4 481.5 1014.5 481.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1063.5 481.5C1064.6 481.5 1065.5 480.605 1065.5 479.5C1065.5 478.395 1064.6 477.5 1063.5 477.5C1062.4 477.5 1061.5 478.395 1061.5 479.5C1061.5 480.605 1062.4 481.5 1063.5 481.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1112.5 481.5C1113.6 481.5 1114.5 480.605 1114.5 479.5C1114.5 478.395 1113.6 477.5 1112.5 477.5C1111.4 477.5 1110.5 478.395 1110.5 479.5C1110.5 480.605 1111.4 481.5 1112.5 481.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1161.5 481.5C1162.6 481.5 1163.5 480.605 1163.5 479.5C1163.5 478.395 1162.6 477.5 1161.5 477.5C1160.4 477.5 1159.5 478.395 1159.5 479.5C1159.5 480.605 1160.4 481.5 1161.5 481.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1210.5 481.5C1211.6 481.5 1212.5 480.605 1212.5 479.5C1212.5 478.395 1211.6 477.5 1210.5 477.5C1209.4 477.5 1208.5 478.395 1208.5 479.5C1208.5 480.605 1209.4 481.5 1210.5 481.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1259.5 481.5C1260.6 481.5 1261.5 480.605 1261.5 479.5C1261.5 478.395 1260.6 477.5 1259.5 477.5C1258.4 477.5 1257.5 478.395 1257.5 479.5C1257.5 480.605 1258.4 481.5 1259.5 481.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1308.5 481.5C1309.6 481.5 1310.5 480.605 1310.5 479.5C1310.5 478.395 1309.6 477.5 1308.5 477.5C1307.4 477.5 1306.5 478.395 1306.5 479.5C1306.5 480.605 1307.4 481.5 1308.5 481.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1357.5 481.5C1358.6 481.5 1359.5 480.605 1359.5 479.5C1359.5 478.395 1358.6 477.5 1357.5 477.5C1356.4 477.5 1355.5 478.395 1355.5 479.5C1355.5 480.605 1356.4 481.5 1357.5 481.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1406.5 481.5C1407.6 481.5 1408.5 480.605 1408.5 479.5C1408.5 478.395 1407.6 477.5 1406.5 477.5C1405.4 477.5 1404.5 478.395 1404.5 479.5C1404.5 480.605 1405.4 481.5 1406.5 481.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.5 530.5C35.6046 530.5 36.5 529.605 36.5 528.5C36.5 527.395 35.6046 526.5 34.5 526.5C33.3954 526.5 32.5 527.395 32.5 528.5C32.5 529.605 33.3954 530.5 34.5 530.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.5 530.5C84.6046 530.5 85.5 529.605 85.5 528.5C85.5 527.395 84.6046 526.5 83.5 526.5C82.3954 526.5 81.5 527.395 81.5 528.5C81.5 529.605 82.3954 530.5 83.5 530.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132.5 530.5C133.605 530.5 134.5 529.605 134.5 528.5C134.5 527.395 133.605 526.5 132.5 526.5C131.395 526.5 130.5 527.395 130.5 528.5C130.5 529.605 131.395 530.5 132.5 530.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M181.5 530.5C182.605 530.5 183.5 529.605 183.5 528.5C183.5 527.395 182.605 526.5 181.5 526.5C180.395 526.5 179.5 527.395 179.5 528.5C179.5 529.605 180.395 530.5 181.5 530.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M230.5 530.5C231.605 530.5 232.5 529.605 232.5 528.5C232.5 527.395 231.605 526.5 230.5 526.5C229.395 526.5 228.5 527.395 228.5 528.5C228.5 529.605 229.395 530.5 230.5 530.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M279.5 530.5C280.605 530.5 281.5 529.605 281.5 528.5C281.5 527.395 280.605 526.5 279.5 526.5C278.395 526.5 277.5 527.395 277.5 528.5C277.5 529.605 278.395 530.5 279.5 530.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M328.5 530.5C329.605 530.5 330.5 529.605 330.5 528.5C330.5 527.395 329.605 526.5 328.5 526.5C327.395 526.5 326.5 527.395 326.5 528.5C326.5 529.605 327.395 530.5 328.5 530.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M377.5 530.5C378.605 530.5 379.5 529.605 379.5 528.5C379.5 527.395 378.605 526.5 377.5 526.5C376.395 526.5 375.5 527.395 375.5 528.5C375.5 529.605 376.395 530.5 377.5 530.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M426.5 530.5C427.605 530.5 428.5 529.605 428.5 528.5C428.5 527.395 427.605 526.5 426.5 526.5C425.395 526.5 424.5 527.395 424.5 528.5C424.5 529.605 425.395 530.5 426.5 530.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M475.5 530.5C476.605 530.5 477.5 529.605 477.5 528.5C477.5 527.395 476.605 526.5 475.5 526.5C474.395 526.5 473.5 527.395 473.5 528.5C473.5 529.605 474.395 530.5 475.5 530.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M524.5 530.5C525.605 530.5 526.5 529.605 526.5 528.5C526.5 527.395 525.605 526.5 524.5 526.5C523.395 526.5 522.5 527.395 522.5 528.5C522.5 529.605 523.395 530.5 524.5 530.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M573.5 530.5C574.605 530.5 575.5 529.605 575.5 528.5C575.5 527.395 574.605 526.5 573.5 526.5C572.395 526.5 571.5 527.395 571.5 528.5C571.5 529.605 572.395 530.5 573.5 530.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M622.5 530.5C623.605 530.5 624.5 529.605 624.5 528.5C624.5 527.395 623.605 526.5 622.5 526.5C621.395 526.5 620.5 527.395 620.5 528.5C620.5 529.605 621.395 530.5 622.5 530.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M671.5 530.5C672.605 530.5 673.5 529.605 673.5 528.5C673.5 527.395 672.605 526.5 671.5 526.5C670.395 526.5 669.5 527.395 669.5 528.5C669.5 529.605 670.395 530.5 671.5 530.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M720.5 530.5C721.605 530.5 722.5 529.605 722.5 528.5C722.5 527.395 721.605 526.5 720.5 526.5C719.395 526.5 718.5 527.395 718.5 528.5C718.5 529.605 719.395 530.5 720.5 530.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M769.5 530.5C770.605 530.5 771.5 529.605 771.5 528.5C771.5 527.395 770.605 526.5 769.5 526.5C768.395 526.5 767.5 527.395 767.5 528.5C767.5 529.605 768.395 530.5 769.5 530.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M818.5 530.5C819.605 530.5 820.5 529.605 820.5 528.5C820.5 527.395 819.605 526.5 818.5 526.5C817.395 526.5 816.5 527.395 816.5 528.5C816.5 529.605 817.395 530.5 818.5 530.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M867.5 530.5C868.605 530.5 869.5 529.605 869.5 528.5C869.5 527.395 868.605 526.5 867.5 526.5C866.395 526.5 865.5 527.395 865.5 528.5C865.5 529.605 866.395 530.5 867.5 530.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M916.5 530.5C917.605 530.5 918.5 529.605 918.5 528.5C918.5 527.395 917.605 526.5 916.5 526.5C915.395 526.5 914.5 527.395 914.5 528.5C914.5 529.605 915.395 530.5 916.5 530.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M965.5 530.5C966.605 530.5 967.5 529.605 967.5 528.5C967.5 527.395 966.605 526.5 965.5 526.5C964.395 526.5 963.5 527.395 963.5 528.5C963.5 529.605 964.395 530.5 965.5 530.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1014.5 530.5C1015.6 530.5 1016.5 529.605 1016.5 528.5C1016.5 527.395 1015.6 526.5 1014.5 526.5C1013.4 526.5 1012.5 527.395 1012.5 528.5C1012.5 529.605 1013.4 530.5 1014.5 530.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1063.5 530.5C1064.6 530.5 1065.5 529.605 1065.5 528.5C1065.5 527.395 1064.6 526.5 1063.5 526.5C1062.4 526.5 1061.5 527.395 1061.5 528.5C1061.5 529.605 1062.4 530.5 1063.5 530.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1112.5 530.5C1113.6 530.5 1114.5 529.605 1114.5 528.5C1114.5 527.395 1113.6 526.5 1112.5 526.5C1111.4 526.5 1110.5 527.395 1110.5 528.5C1110.5 529.605 1111.4 530.5 1112.5 530.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1161.5 530.5C1162.6 530.5 1163.5 529.605 1163.5 528.5C1163.5 527.395 1162.6 526.5 1161.5 526.5C1160.4 526.5 1159.5 527.395 1159.5 528.5C1159.5 529.605 1160.4 530.5 1161.5 530.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1210.5 530.5C1211.6 530.5 1212.5 529.605 1212.5 528.5C1212.5 527.395 1211.6 526.5 1210.5 526.5C1209.4 526.5 1208.5 527.395 1208.5 528.5C1208.5 529.605 1209.4 530.5 1210.5 530.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1259.5 530.5C1260.6 530.5 1261.5 529.605 1261.5 528.5C1261.5 527.395 1260.6 526.5 1259.5 526.5C1258.4 526.5 1257.5 527.395 1257.5 528.5C1257.5 529.605 1258.4 530.5 1259.5 530.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1308.5 530.5C1309.6 530.5 1310.5 529.605 1310.5 528.5C1310.5 527.395 1309.6 526.5 1308.5 526.5C1307.4 526.5 1306.5 527.395 1306.5 528.5C1306.5 529.605 1307.4 530.5 1308.5 530.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1357.5 530.5C1358.6 530.5 1359.5 529.605 1359.5 528.5C1359.5 527.395 1358.6 526.5 1357.5 526.5C1356.4 526.5 1355.5 527.395 1355.5 528.5C1355.5 529.605 1356.4 530.5 1357.5 530.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1406.5 530.5C1407.6 530.5 1408.5 529.605 1408.5 528.5C1408.5 527.395 1407.6 526.5 1406.5 526.5C1405.4 526.5 1404.5 527.395 1404.5 528.5C1404.5 529.605 1405.4 530.5 1406.5 530.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.5 579.5C35.6046 579.5 36.5 578.605 36.5 577.5C36.5 576.395 35.6046 575.5 34.5 575.5C33.3954 575.5 32.5 576.395 32.5 577.5C32.5 578.605 33.3954 579.5 34.5 579.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.5 579.5C84.6046 579.5 85.5 578.605 85.5 577.5C85.5 576.395 84.6046 575.5 83.5 575.5C82.3954 575.5 81.5 576.395 81.5 577.5C81.5 578.605 82.3954 579.5 83.5 579.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132.5 579.5C133.605 579.5 134.5 578.605 134.5 577.5C134.5 576.395 133.605 575.5 132.5 575.5C131.395 575.5 130.5 576.395 130.5 577.5C130.5 578.605 131.395 579.5 132.5 579.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M181.5 579.5C182.605 579.5 183.5 578.605 183.5 577.5C183.5 576.395 182.605 575.5 181.5 575.5C180.395 575.5 179.5 576.395 179.5 577.5C179.5 578.605 180.395 579.5 181.5 579.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M230.5 579.5C231.605 579.5 232.5 578.605 232.5 577.5C232.5 576.395 231.605 575.5 230.5 575.5C229.395 575.5 228.5 576.395 228.5 577.5C228.5 578.605 229.395 579.5 230.5 579.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M279.5 579.5C280.605 579.5 281.5 578.605 281.5 577.5C281.5 576.395 280.605 575.5 279.5 575.5C278.395 575.5 277.5 576.395 277.5 577.5C277.5 578.605 278.395 579.5 279.5 579.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M328.5 579.5C329.605 579.5 330.5 578.605 330.5 577.5C330.5 576.395 329.605 575.5 328.5 575.5C327.395 575.5 326.5 576.395 326.5 577.5C326.5 578.605 327.395 579.5 328.5 579.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M377.5 579.5C378.605 579.5 379.5 578.605 379.5 577.5C379.5 576.395 378.605 575.5 377.5 575.5C376.395 575.5 375.5 576.395 375.5 577.5C375.5 578.605 376.395 579.5 377.5 579.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M426.5 579.5C427.605 579.5 428.5 578.605 428.5 577.5C428.5 576.395 427.605 575.5 426.5 575.5C425.395 575.5 424.5 576.395 424.5 577.5C424.5 578.605 425.395 579.5 426.5 579.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M475.5 579.5C476.605 579.5 477.5 578.605 477.5 577.5C477.5 576.395 476.605 575.5 475.5 575.5C474.395 575.5 473.5 576.395 473.5 577.5C473.5 578.605 474.395 579.5 475.5 579.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M524.5 579.5C525.605 579.5 526.5 578.605 526.5 577.5C526.5 576.395 525.605 575.5 524.5 575.5C523.395 575.5 522.5 576.395 522.5 577.5C522.5 578.605 523.395 579.5 524.5 579.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M573.5 579.5C574.605 579.5 575.5 578.605 575.5 577.5C575.5 576.395 574.605 575.5 573.5 575.5C572.395 575.5 571.5 576.395 571.5 577.5C571.5 578.605 572.395 579.5 573.5 579.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M622.5 579.5C623.605 579.5 624.5 578.605 624.5 577.5C624.5 576.395 623.605 575.5 622.5 575.5C621.395 575.5 620.5 576.395 620.5 577.5C620.5 578.605 621.395 579.5 622.5 579.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M671.5 579.5C672.605 579.5 673.5 578.605 673.5 577.5C673.5 576.395 672.605 575.5 671.5 575.5C670.395 575.5 669.5 576.395 669.5 577.5C669.5 578.605 670.395 579.5 671.5 579.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M720.5 579.5C721.605 579.5 722.5 578.605 722.5 577.5C722.5 576.395 721.605 575.5 720.5 575.5C719.395 575.5 718.5 576.395 718.5 577.5C718.5 578.605 719.395 579.5 720.5 579.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M769.5 579.5C770.605 579.5 771.5 578.605 771.5 577.5C771.5 576.395 770.605 575.5 769.5 575.5C768.395 575.5 767.5 576.395 767.5 577.5C767.5 578.605 768.395 579.5 769.5 579.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M818.5 579.5C819.605 579.5 820.5 578.605 820.5 577.5C820.5 576.395 819.605 575.5 818.5 575.5C817.395 575.5 816.5 576.395 816.5 577.5C816.5 578.605 817.395 579.5 818.5 579.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M867.5 579.5C868.605 579.5 869.5 578.605 869.5 577.5C869.5 576.395 868.605 575.5 867.5 575.5C866.395 575.5 865.5 576.395 865.5 577.5C865.5 578.605 866.395 579.5 867.5 579.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M916.5 579.5C917.605 579.5 918.5 578.605 918.5 577.5C918.5 576.395 917.605 575.5 916.5 575.5C915.395 575.5 914.5 576.395 914.5 577.5C914.5 578.605 915.395 579.5 916.5 579.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M965.5 579.5C966.605 579.5 967.5 578.605 967.5 577.5C967.5 576.395 966.605 575.5 965.5 575.5C964.395 575.5 963.5 576.395 963.5 577.5C963.5 578.605 964.395 579.5 965.5 579.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1014.5 579.5C1015.6 579.5 1016.5 578.605 1016.5 577.5C1016.5 576.395 1015.6 575.5 1014.5 575.5C1013.4 575.5 1012.5 576.395 1012.5 577.5C1012.5 578.605 1013.4 579.5 1014.5 579.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1063.5 579.5C1064.6 579.5 1065.5 578.605 1065.5 577.5C1065.5 576.395 1064.6 575.5 1063.5 575.5C1062.4 575.5 1061.5 576.395 1061.5 577.5C1061.5 578.605 1062.4 579.5 1063.5 579.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1112.5 579.5C1113.6 579.5 1114.5 578.605 1114.5 577.5C1114.5 576.395 1113.6 575.5 1112.5 575.5C1111.4 575.5 1110.5 576.395 1110.5 577.5C1110.5 578.605 1111.4 579.5 1112.5 579.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1161.5 579.5C1162.6 579.5 1163.5 578.605 1163.5 577.5C1163.5 576.395 1162.6 575.5 1161.5 575.5C1160.4 575.5 1159.5 576.395 1159.5 577.5C1159.5 578.605 1160.4 579.5 1161.5 579.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1210.5 579.5C1211.6 579.5 1212.5 578.605 1212.5 577.5C1212.5 576.395 1211.6 575.5 1210.5 575.5C1209.4 575.5 1208.5 576.395 1208.5 577.5C1208.5 578.605 1209.4 579.5 1210.5 579.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1259.5 579.5C1260.6 579.5 1261.5 578.605 1261.5 577.5C1261.5 576.395 1260.6 575.5 1259.5 575.5C1258.4 575.5 1257.5 576.395 1257.5 577.5C1257.5 578.605 1258.4 579.5 1259.5 579.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1308.5 579.5C1309.6 579.5 1310.5 578.605 1310.5 577.5C1310.5 576.395 1309.6 575.5 1308.5 575.5C1307.4 575.5 1306.5 576.395 1306.5 577.5C1306.5 578.605 1307.4 579.5 1308.5 579.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1357.5 579.5C1358.6 579.5 1359.5 578.605 1359.5 577.5C1359.5 576.395 1358.6 575.5 1357.5 575.5C1356.4 575.5 1355.5 576.395 1355.5 577.5C1355.5 578.605 1356.4 579.5 1357.5 579.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1406.5 579.5C1407.6 579.5 1408.5 578.605 1408.5 577.5C1408.5 576.395 1407.6 575.5 1406.5 575.5C1405.4 575.5 1404.5 576.395 1404.5 577.5C1404.5 578.605 1405.4 579.5 1406.5 579.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.5 628.5C35.6046 628.5 36.5 627.605 36.5 626.5C36.5 625.395 35.6046 624.5 34.5 624.5C33.3954 624.5 32.5 625.395 32.5 626.5C32.5 627.605 33.3954 628.5 34.5 628.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.5 628.5C84.6046 628.5 85.5 627.605 85.5 626.5C85.5 625.395 84.6046 624.5 83.5 624.5C82.3954 624.5 81.5 625.395 81.5 626.5C81.5 627.605 82.3954 628.5 83.5 628.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132.5 628.5C133.605 628.5 134.5 627.605 134.5 626.5C134.5 625.395 133.605 624.5 132.5 624.5C131.395 624.5 130.5 625.395 130.5 626.5C130.5 627.605 131.395 628.5 132.5 628.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M181.5 628.5C182.605 628.5 183.5 627.605 183.5 626.5C183.5 625.395 182.605 624.5 181.5 624.5C180.395 624.5 179.5 625.395 179.5 626.5C179.5 627.605 180.395 628.5 181.5 628.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M230.5 628.5C231.605 628.5 232.5 627.605 232.5 626.5C232.5 625.395 231.605 624.5 230.5 624.5C229.395 624.5 228.5 625.395 228.5 626.5C228.5 627.605 229.395 628.5 230.5 628.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M279.5 628.5C280.605 628.5 281.5 627.605 281.5 626.5C281.5 625.395 280.605 624.5 279.5 624.5C278.395 624.5 277.5 625.395 277.5 626.5C277.5 627.605 278.395 628.5 279.5 628.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M328.5 628.5C329.605 628.5 330.5 627.605 330.5 626.5C330.5 625.395 329.605 624.5 328.5 624.5C327.395 624.5 326.5 625.395 326.5 626.5C326.5 627.605 327.395 628.5 328.5 628.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M377.5 628.5C378.605 628.5 379.5 627.605 379.5 626.5C379.5 625.395 378.605 624.5 377.5 624.5C376.395 624.5 375.5 625.395 375.5 626.5C375.5 627.605 376.395 628.5 377.5 628.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M426.5 628.5C427.605 628.5 428.5 627.605 428.5 626.5C428.5 625.395 427.605 624.5 426.5 624.5C425.395 624.5 424.5 625.395 424.5 626.5C424.5 627.605 425.395 628.5 426.5 628.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M475.5 628.5C476.605 628.5 477.5 627.605 477.5 626.5C477.5 625.395 476.605 624.5 475.5 624.5C474.395 624.5 473.5 625.395 473.5 626.5C473.5 627.605 474.395 628.5 475.5 628.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M524.5 628.5C525.605 628.5 526.5 627.605 526.5 626.5C526.5 625.395 525.605 624.5 524.5 624.5C523.395 624.5 522.5 625.395 522.5 626.5C522.5 627.605 523.395 628.5 524.5 628.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M573.5 628.5C574.605 628.5 575.5 627.605 575.5 626.5C575.5 625.395 574.605 624.5 573.5 624.5C572.395 624.5 571.5 625.395 571.5 626.5C571.5 627.605 572.395 628.5 573.5 628.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M622.5 628.5C623.605 628.5 624.5 627.605 624.5 626.5C624.5 625.395 623.605 624.5 622.5 624.5C621.395 624.5 620.5 625.395 620.5 626.5C620.5 627.605 621.395 628.5 622.5 628.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M671.5 628.5C672.605 628.5 673.5 627.605 673.5 626.5C673.5 625.395 672.605 624.5 671.5 624.5C670.395 624.5 669.5 625.395 669.5 626.5C669.5 627.605 670.395 628.5 671.5 628.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M720.5 628.5C721.605 628.5 722.5 627.605 722.5 626.5C722.5 625.395 721.605 624.5 720.5 624.5C719.395 624.5 718.5 625.395 718.5 626.5C718.5 627.605 719.395 628.5 720.5 628.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M769.5 628.5C770.605 628.5 771.5 627.605 771.5 626.5C771.5 625.395 770.605 624.5 769.5 624.5C768.395 624.5 767.5 625.395 767.5 626.5C767.5 627.605 768.395 628.5 769.5 628.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M818.5 628.5C819.605 628.5 820.5 627.605 820.5 626.5C820.5 625.395 819.605 624.5 818.5 624.5C817.395 624.5 816.5 625.395 816.5 626.5C816.5 627.605 817.395 628.5 818.5 628.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M867.5 628.5C868.605 628.5 869.5 627.605 869.5 626.5C869.5 625.395 868.605 624.5 867.5 624.5C866.395 624.5 865.5 625.395 865.5 626.5C865.5 627.605 866.395 628.5 867.5 628.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M916.5 628.5C917.605 628.5 918.5 627.605 918.5 626.5C918.5 625.395 917.605 624.5 916.5 624.5C915.395 624.5 914.5 625.395 914.5 626.5C914.5 627.605 915.395 628.5 916.5 628.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M965.5 628.5C966.605 628.5 967.5 627.605 967.5 626.5C967.5 625.395 966.605 624.5 965.5 624.5C964.395 624.5 963.5 625.395 963.5 626.5C963.5 627.605 964.395 628.5 965.5 628.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1014.5 628.5C1015.6 628.5 1016.5 627.605 1016.5 626.5C1016.5 625.395 1015.6 624.5 1014.5 624.5C1013.4 624.5 1012.5 625.395 1012.5 626.5C1012.5 627.605 1013.4 628.5 1014.5 628.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1063.5 628.5C1064.6 628.5 1065.5 627.605 1065.5 626.5C1065.5 625.395 1064.6 624.5 1063.5 624.5C1062.4 624.5 1061.5 625.395 1061.5 626.5C1061.5 627.605 1062.4 628.5 1063.5 628.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1112.5 628.5C1113.6 628.5 1114.5 627.605 1114.5 626.5C1114.5 625.395 1113.6 624.5 1112.5 624.5C1111.4 624.5 1110.5 625.395 1110.5 626.5C1110.5 627.605 1111.4 628.5 1112.5 628.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1161.5 628.5C1162.6 628.5 1163.5 627.605 1163.5 626.5C1163.5 625.395 1162.6 624.5 1161.5 624.5C1160.4 624.5 1159.5 625.395 1159.5 626.5C1159.5 627.605 1160.4 628.5 1161.5 628.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1210.5 628.5C1211.6 628.5 1212.5 627.605 1212.5 626.5C1212.5 625.395 1211.6 624.5 1210.5 624.5C1209.4 624.5 1208.5 625.395 1208.5 626.5C1208.5 627.605 1209.4 628.5 1210.5 628.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1259.5 628.5C1260.6 628.5 1261.5 627.605 1261.5 626.5C1261.5 625.395 1260.6 624.5 1259.5 624.5C1258.4 624.5 1257.5 625.395 1257.5 626.5C1257.5 627.605 1258.4 628.5 1259.5 628.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1308.5 628.5C1309.6 628.5 1310.5 627.605 1310.5 626.5C1310.5 625.395 1309.6 624.5 1308.5 624.5C1307.4 624.5 1306.5 625.395 1306.5 626.5C1306.5 627.605 1307.4 628.5 1308.5 628.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1357.5 628.5C1358.6 628.5 1359.5 627.605 1359.5 626.5C1359.5 625.395 1358.6 624.5 1357.5 624.5C1356.4 624.5 1355.5 625.395 1355.5 626.5C1355.5 627.605 1356.4 628.5 1357.5 628.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1406.5 628.5C1407.6 628.5 1408.5 627.605 1408.5 626.5C1408.5 625.395 1407.6 624.5 1406.5 624.5C1405.4 624.5 1404.5 625.395 1404.5 626.5C1404.5 627.605 1405.4 628.5 1406.5 628.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.5 677.5C35.6046 677.5 36.5 676.605 36.5 675.5C36.5 674.395 35.6046 673.5 34.5 673.5C33.3954 673.5 32.5 674.395 32.5 675.5C32.5 676.605 33.3954 677.5 34.5 677.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.5 677.5C84.6046 677.5 85.5 676.605 85.5 675.5C85.5 674.395 84.6046 673.5 83.5 673.5C82.3954 673.5 81.5 674.395 81.5 675.5C81.5 676.605 82.3954 677.5 83.5 677.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132.5 677.5C133.605 677.5 134.5 676.605 134.5 675.5C134.5 674.395 133.605 673.5 132.5 673.5C131.395 673.5 130.5 674.395 130.5 675.5C130.5 676.605 131.395 677.5 132.5 677.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M181.5 677.5C182.605 677.5 183.5 676.605 183.5 675.5C183.5 674.395 182.605 673.5 181.5 673.5C180.395 673.5 179.5 674.395 179.5 675.5C179.5 676.605 180.395 677.5 181.5 677.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M230.5 677.5C231.605 677.5 232.5 676.605 232.5 675.5C232.5 674.395 231.605 673.5 230.5 673.5C229.395 673.5 228.5 674.395 228.5 675.5C228.5 676.605 229.395 677.5 230.5 677.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M279.5 677.5C280.605 677.5 281.5 676.605 281.5 675.5C281.5 674.395 280.605 673.5 279.5 673.5C278.395 673.5 277.5 674.395 277.5 675.5C277.5 676.605 278.395 677.5 279.5 677.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M328.5 677.5C329.605 677.5 330.5 676.605 330.5 675.5C330.5 674.395 329.605 673.5 328.5 673.5C327.395 673.5 326.5 674.395 326.5 675.5C326.5 676.605 327.395 677.5 328.5 677.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M377.5 677.5C378.605 677.5 379.5 676.605 379.5 675.5C379.5 674.395 378.605 673.5 377.5 673.5C376.395 673.5 375.5 674.395 375.5 675.5C375.5 676.605 376.395 677.5 377.5 677.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M426.5 677.5C427.605 677.5 428.5 676.605 428.5 675.5C428.5 674.395 427.605 673.5 426.5 673.5C425.395 673.5 424.5 674.395 424.5 675.5C424.5 676.605 425.395 677.5 426.5 677.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M475.5 677.5C476.605 677.5 477.5 676.605 477.5 675.5C477.5 674.395 476.605 673.5 475.5 673.5C474.395 673.5 473.5 674.395 473.5 675.5C473.5 676.605 474.395 677.5 475.5 677.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M524.5 677.5C525.605 677.5 526.5 676.605 526.5 675.5C526.5 674.395 525.605 673.5 524.5 673.5C523.395 673.5 522.5 674.395 522.5 675.5C522.5 676.605 523.395 677.5 524.5 677.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M573.5 677.5C574.605 677.5 575.5 676.605 575.5 675.5C575.5 674.395 574.605 673.5 573.5 673.5C572.395 673.5 571.5 674.395 571.5 675.5C571.5 676.605 572.395 677.5 573.5 677.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M622.5 677.5C623.605 677.5 624.5 676.605 624.5 675.5C624.5 674.395 623.605 673.5 622.5 673.5C621.395 673.5 620.5 674.395 620.5 675.5C620.5 676.605 621.395 677.5 622.5 677.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M671.5 677.5C672.605 677.5 673.5 676.605 673.5 675.5C673.5 674.395 672.605 673.5 671.5 673.5C670.395 673.5 669.5 674.395 669.5 675.5C669.5 676.605 670.395 677.5 671.5 677.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M720.5 677.5C721.605 677.5 722.5 676.605 722.5 675.5C722.5 674.395 721.605 673.5 720.5 673.5C719.395 673.5 718.5 674.395 718.5 675.5C718.5 676.605 719.395 677.5 720.5 677.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M769.5 677.5C770.605 677.5 771.5 676.605 771.5 675.5C771.5 674.395 770.605 673.5 769.5 673.5C768.395 673.5 767.5 674.395 767.5 675.5C767.5 676.605 768.395 677.5 769.5 677.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M818.5 677.5C819.605 677.5 820.5 676.605 820.5 675.5C820.5 674.395 819.605 673.5 818.5 673.5C817.395 673.5 816.5 674.395 816.5 675.5C816.5 676.605 817.395 677.5 818.5 677.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M867.5 677.5C868.605 677.5 869.5 676.605 869.5 675.5C869.5 674.395 868.605 673.5 867.5 673.5C866.395 673.5 865.5 674.395 865.5 675.5C865.5 676.605 866.395 677.5 867.5 677.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M916.5 677.5C917.605 677.5 918.5 676.605 918.5 675.5C918.5 674.395 917.605 673.5 916.5 673.5C915.395 673.5 914.5 674.395 914.5 675.5C914.5 676.605 915.395 677.5 916.5 677.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M965.5 677.5C966.605 677.5 967.5 676.605 967.5 675.5C967.5 674.395 966.605 673.5 965.5 673.5C964.395 673.5 963.5 674.395 963.5 675.5C963.5 676.605 964.395 677.5 965.5 677.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1014.5 677.5C1015.6 677.5 1016.5 676.605 1016.5 675.5C1016.5 674.395 1015.6 673.5 1014.5 673.5C1013.4 673.5 1012.5 674.395 1012.5 675.5C1012.5 676.605 1013.4 677.5 1014.5 677.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1063.5 677.5C1064.6 677.5 1065.5 676.605 1065.5 675.5C1065.5 674.395 1064.6 673.5 1063.5 673.5C1062.4 673.5 1061.5 674.395 1061.5 675.5C1061.5 676.605 1062.4 677.5 1063.5 677.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1112.5 677.5C1113.6 677.5 1114.5 676.605 1114.5 675.5C1114.5 674.395 1113.6 673.5 1112.5 673.5C1111.4 673.5 1110.5 674.395 1110.5 675.5C1110.5 676.605 1111.4 677.5 1112.5 677.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1161.5 677.5C1162.6 677.5 1163.5 676.605 1163.5 675.5C1163.5 674.395 1162.6 673.5 1161.5 673.5C1160.4 673.5 1159.5 674.395 1159.5 675.5C1159.5 676.605 1160.4 677.5 1161.5 677.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1210.5 677.5C1211.6 677.5 1212.5 676.605 1212.5 675.5C1212.5 674.395 1211.6 673.5 1210.5 673.5C1209.4 673.5 1208.5 674.395 1208.5 675.5C1208.5 676.605 1209.4 677.5 1210.5 677.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1259.5 677.5C1260.6 677.5 1261.5 676.605 1261.5 675.5C1261.5 674.395 1260.6 673.5 1259.5 673.5C1258.4 673.5 1257.5 674.395 1257.5 675.5C1257.5 676.605 1258.4 677.5 1259.5 677.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1308.5 677.5C1309.6 677.5 1310.5 676.605 1310.5 675.5C1310.5 674.395 1309.6 673.5 1308.5 673.5C1307.4 673.5 1306.5 674.395 1306.5 675.5C1306.5 676.605 1307.4 677.5 1308.5 677.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1357.5 677.5C1358.6 677.5 1359.5 676.605 1359.5 675.5C1359.5 674.395 1358.6 673.5 1357.5 673.5C1356.4 673.5 1355.5 674.395 1355.5 675.5C1355.5 676.605 1356.4 677.5 1357.5 677.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1406.5 677.5C1407.6 677.5 1408.5 676.605 1408.5 675.5C1408.5 674.395 1407.6 673.5 1406.5 673.5C1405.4 673.5 1404.5 674.395 1404.5 675.5C1404.5 676.605 1405.4 677.5 1406.5 677.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.5 726.5C35.6046 726.5 36.5 725.605 36.5 724.5C36.5 723.395 35.6046 722.5 34.5 722.5C33.3954 722.5 32.5 723.395 32.5 724.5C32.5 725.605 33.3954 726.5 34.5 726.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.5 726.5C84.6046 726.5 85.5 725.605 85.5 724.5C85.5 723.395 84.6046 722.5 83.5 722.5C82.3954 722.5 81.5 723.395 81.5 724.5C81.5 725.605 82.3954 726.5 83.5 726.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132.5 726.5C133.605 726.5 134.5 725.605 134.5 724.5C134.5 723.395 133.605 722.5 132.5 722.5C131.395 722.5 130.5 723.395 130.5 724.5C130.5 725.605 131.395 726.5 132.5 726.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M181.5 726.5C182.605 726.5 183.5 725.605 183.5 724.5C183.5 723.395 182.605 722.5 181.5 722.5C180.395 722.5 179.5 723.395 179.5 724.5C179.5 725.605 180.395 726.5 181.5 726.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M230.5 726.5C231.605 726.5 232.5 725.605 232.5 724.5C232.5 723.395 231.605 722.5 230.5 722.5C229.395 722.5 228.5 723.395 228.5 724.5C228.5 725.605 229.395 726.5 230.5 726.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M279.5 726.5C280.605 726.5 281.5 725.605 281.5 724.5C281.5 723.395 280.605 722.5 279.5 722.5C278.395 722.5 277.5 723.395 277.5 724.5C277.5 725.605 278.395 726.5 279.5 726.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M328.5 726.5C329.605 726.5 330.5 725.605 330.5 724.5C330.5 723.395 329.605 722.5 328.5 722.5C327.395 722.5 326.5 723.395 326.5 724.5C326.5 725.605 327.395 726.5 328.5 726.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M377.5 726.5C378.605 726.5 379.5 725.605 379.5 724.5C379.5 723.395 378.605 722.5 377.5 722.5C376.395 722.5 375.5 723.395 375.5 724.5C375.5 725.605 376.395 726.5 377.5 726.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M426.5 726.5C427.605 726.5 428.5 725.605 428.5 724.5C428.5 723.395 427.605 722.5 426.5 722.5C425.395 722.5 424.5 723.395 424.5 724.5C424.5 725.605 425.395 726.5 426.5 726.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M475.5 726.5C476.605 726.5 477.5 725.605 477.5 724.5C477.5 723.395 476.605 722.5 475.5 722.5C474.395 722.5 473.5 723.395 473.5 724.5C473.5 725.605 474.395 726.5 475.5 726.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M524.5 726.5C525.605 726.5 526.5 725.605 526.5 724.5C526.5 723.395 525.605 722.5 524.5 722.5C523.395 722.5 522.5 723.395 522.5 724.5C522.5 725.605 523.395 726.5 524.5 726.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M573.5 726.5C574.605 726.5 575.5 725.605 575.5 724.5C575.5 723.395 574.605 722.5 573.5 722.5C572.395 722.5 571.5 723.395 571.5 724.5C571.5 725.605 572.395 726.5 573.5 726.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M622.5 726.5C623.605 726.5 624.5 725.605 624.5 724.5C624.5 723.395 623.605 722.5 622.5 722.5C621.395 722.5 620.5 723.395 620.5 724.5C620.5 725.605 621.395 726.5 622.5 726.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M671.5 726.5C672.605 726.5 673.5 725.605 673.5 724.5C673.5 723.395 672.605 722.5 671.5 722.5C670.395 722.5 669.5 723.395 669.5 724.5C669.5 725.605 670.395 726.5 671.5 726.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M720.5 726.5C721.605 726.5 722.5 725.605 722.5 724.5C722.5 723.395 721.605 722.5 720.5 722.5C719.395 722.5 718.5 723.395 718.5 724.5C718.5 725.605 719.395 726.5 720.5 726.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M769.5 726.5C770.605 726.5 771.5 725.605 771.5 724.5C771.5 723.395 770.605 722.5 769.5 722.5C768.395 722.5 767.5 723.395 767.5 724.5C767.5 725.605 768.395 726.5 769.5 726.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M818.5 726.5C819.605 726.5 820.5 725.605 820.5 724.5C820.5 723.395 819.605 722.5 818.5 722.5C817.395 722.5 816.5 723.395 816.5 724.5C816.5 725.605 817.395 726.5 818.5 726.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M867.5 726.5C868.605 726.5 869.5 725.605 869.5 724.5C869.5 723.395 868.605 722.5 867.5 722.5C866.395 722.5 865.5 723.395 865.5 724.5C865.5 725.605 866.395 726.5 867.5 726.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M916.5 726.5C917.605 726.5 918.5 725.605 918.5 724.5C918.5 723.395 917.605 722.5 916.5 722.5C915.395 722.5 914.5 723.395 914.5 724.5C914.5 725.605 915.395 726.5 916.5 726.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M965.5 726.5C966.605 726.5 967.5 725.605 967.5 724.5C967.5 723.395 966.605 722.5 965.5 722.5C964.395 722.5 963.5 723.395 963.5 724.5C963.5 725.605 964.395 726.5 965.5 726.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1014.5 726.5C1015.6 726.5 1016.5 725.605 1016.5 724.5C1016.5 723.395 1015.6 722.5 1014.5 722.5C1013.4 722.5 1012.5 723.395 1012.5 724.5C1012.5 725.605 1013.4 726.5 1014.5 726.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1063.5 726.5C1064.6 726.5 1065.5 725.605 1065.5 724.5C1065.5 723.395 1064.6 722.5 1063.5 722.5C1062.4 722.5 1061.5 723.395 1061.5 724.5C1061.5 725.605 1062.4 726.5 1063.5 726.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1112.5 726.5C1113.6 726.5 1114.5 725.605 1114.5 724.5C1114.5 723.395 1113.6 722.5 1112.5 722.5C1111.4 722.5 1110.5 723.395 1110.5 724.5C1110.5 725.605 1111.4 726.5 1112.5 726.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1161.5 726.5C1162.6 726.5 1163.5 725.605 1163.5 724.5C1163.5 723.395 1162.6 722.5 1161.5 722.5C1160.4 722.5 1159.5 723.395 1159.5 724.5C1159.5 725.605 1160.4 726.5 1161.5 726.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1210.5 726.5C1211.6 726.5 1212.5 725.605 1212.5 724.5C1212.5 723.395 1211.6 722.5 1210.5 722.5C1209.4 722.5 1208.5 723.395 1208.5 724.5C1208.5 725.605 1209.4 726.5 1210.5 726.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1259.5 726.5C1260.6 726.5 1261.5 725.605 1261.5 724.5C1261.5 723.395 1260.6 722.5 1259.5 722.5C1258.4 722.5 1257.5 723.395 1257.5 724.5C1257.5 725.605 1258.4 726.5 1259.5 726.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1308.5 726.5C1309.6 726.5 1310.5 725.605 1310.5 724.5C1310.5 723.395 1309.6 722.5 1308.5 722.5C1307.4 722.5 1306.5 723.395 1306.5 724.5C1306.5 725.605 1307.4 726.5 1308.5 726.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1357.5 726.5C1358.6 726.5 1359.5 725.605 1359.5 724.5C1359.5 723.395 1358.6 722.5 1357.5 722.5C1356.4 722.5 1355.5 723.395 1355.5 724.5C1355.5 725.605 1356.4 726.5 1357.5 726.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1406.5 726.5C1407.6 726.5 1408.5 725.605 1408.5 724.5C1408.5 723.395 1407.6 722.5 1406.5 722.5C1405.4 722.5 1404.5 723.395 1404.5 724.5C1404.5 725.605 1405.4 726.5 1406.5 726.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.5 775.5C35.6046 775.5 36.5 774.605 36.5 773.5C36.5 772.395 35.6046 771.5 34.5 771.5C33.3954 771.5 32.5 772.395 32.5 773.5C32.5 774.605 33.3954 775.5 34.5 775.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.5 775.5C84.6046 775.5 85.5 774.605 85.5 773.5C85.5 772.395 84.6046 771.5 83.5 771.5C82.3954 771.5 81.5 772.395 81.5 773.5C81.5 774.605 82.3954 775.5 83.5 775.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132.5 775.5C133.605 775.5 134.5 774.605 134.5 773.5C134.5 772.395 133.605 771.5 132.5 771.5C131.395 771.5 130.5 772.395 130.5 773.5C130.5 774.605 131.395 775.5 132.5 775.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M181.5 775.5C182.605 775.5 183.5 774.605 183.5 773.5C183.5 772.395 182.605 771.5 181.5 771.5C180.395 771.5 179.5 772.395 179.5 773.5C179.5 774.605 180.395 775.5 181.5 775.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M230.5 775.5C231.605 775.5 232.5 774.605 232.5 773.5C232.5 772.395 231.605 771.5 230.5 771.5C229.395 771.5 228.5 772.395 228.5 773.5C228.5 774.605 229.395 775.5 230.5 775.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M279.5 775.5C280.605 775.5 281.5 774.605 281.5 773.5C281.5 772.395 280.605 771.5 279.5 771.5C278.395 771.5 277.5 772.395 277.5 773.5C277.5 774.605 278.395 775.5 279.5 775.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M328.5 775.5C329.605 775.5 330.5 774.605 330.5 773.5C330.5 772.395 329.605 771.5 328.5 771.5C327.395 771.5 326.5 772.395 326.5 773.5C326.5 774.605 327.395 775.5 328.5 775.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M377.5 775.5C378.605 775.5 379.5 774.605 379.5 773.5C379.5 772.395 378.605 771.5 377.5 771.5C376.395 771.5 375.5 772.395 375.5 773.5C375.5 774.605 376.395 775.5 377.5 775.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M426.5 775.5C427.605 775.5 428.5 774.605 428.5 773.5C428.5 772.395 427.605 771.5 426.5 771.5C425.395 771.5 424.5 772.395 424.5 773.5C424.5 774.605 425.395 775.5 426.5 775.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M475.5 775.5C476.605 775.5 477.5 774.605 477.5 773.5C477.5 772.395 476.605 771.5 475.5 771.5C474.395 771.5 473.5 772.395 473.5 773.5C473.5 774.605 474.395 775.5 475.5 775.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M524.5 775.5C525.605 775.5 526.5 774.605 526.5 773.5C526.5 772.395 525.605 771.5 524.5 771.5C523.395 771.5 522.5 772.395 522.5 773.5C522.5 774.605 523.395 775.5 524.5 775.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M573.5 775.5C574.605 775.5 575.5 774.605 575.5 773.5C575.5 772.395 574.605 771.5 573.5 771.5C572.395 771.5 571.5 772.395 571.5 773.5C571.5 774.605 572.395 775.5 573.5 775.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M622.5 775.5C623.605 775.5 624.5 774.605 624.5 773.5C624.5 772.395 623.605 771.5 622.5 771.5C621.395 771.5 620.5 772.395 620.5 773.5C620.5 774.605 621.395 775.5 622.5 775.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M671.5 775.5C672.605 775.5 673.5 774.605 673.5 773.5C673.5 772.395 672.605 771.5 671.5 771.5C670.395 771.5 669.5 772.395 669.5 773.5C669.5 774.605 670.395 775.5 671.5 775.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M720.5 775.5C721.605 775.5 722.5 774.605 722.5 773.5C722.5 772.395 721.605 771.5 720.5 771.5C719.395 771.5 718.5 772.395 718.5 773.5C718.5 774.605 719.395 775.5 720.5 775.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M769.5 775.5C770.605 775.5 771.5 774.605 771.5 773.5C771.5 772.395 770.605 771.5 769.5 771.5C768.395 771.5 767.5 772.395 767.5 773.5C767.5 774.605 768.395 775.5 769.5 775.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M818.5 775.5C819.605 775.5 820.5 774.605 820.5 773.5C820.5 772.395 819.605 771.5 818.5 771.5C817.395 771.5 816.5 772.395 816.5 773.5C816.5 774.605 817.395 775.5 818.5 775.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M867.5 775.5C868.605 775.5 869.5 774.605 869.5 773.5C869.5 772.395 868.605 771.5 867.5 771.5C866.395 771.5 865.5 772.395 865.5 773.5C865.5 774.605 866.395 775.5 867.5 775.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M916.5 775.5C917.605 775.5 918.5 774.605 918.5 773.5C918.5 772.395 917.605 771.5 916.5 771.5C915.395 771.5 914.5 772.395 914.5 773.5C914.5 774.605 915.395 775.5 916.5 775.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M965.5 775.5C966.605 775.5 967.5 774.605 967.5 773.5C967.5 772.395 966.605 771.5 965.5 771.5C964.395 771.5 963.5 772.395 963.5 773.5C963.5 774.605 964.395 775.5 965.5 775.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1014.5 775.5C1015.6 775.5 1016.5 774.605 1016.5 773.5C1016.5 772.395 1015.6 771.5 1014.5 771.5C1013.4 771.5 1012.5 772.395 1012.5 773.5C1012.5 774.605 1013.4 775.5 1014.5 775.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1063.5 775.5C1064.6 775.5 1065.5 774.605 1065.5 773.5C1065.5 772.395 1064.6 771.5 1063.5 771.5C1062.4 771.5 1061.5 772.395 1061.5 773.5C1061.5 774.605 1062.4 775.5 1063.5 775.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1112.5 775.5C1113.6 775.5 1114.5 774.605 1114.5 773.5C1114.5 772.395 1113.6 771.5 1112.5 771.5C1111.4 771.5 1110.5 772.395 1110.5 773.5C1110.5 774.605 1111.4 775.5 1112.5 775.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1161.5 775.5C1162.6 775.5 1163.5 774.605 1163.5 773.5C1163.5 772.395 1162.6 771.5 1161.5 771.5C1160.4 771.5 1159.5 772.395 1159.5 773.5C1159.5 774.605 1160.4 775.5 1161.5 775.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1210.5 775.5C1211.6 775.5 1212.5 774.605 1212.5 773.5C1212.5 772.395 1211.6 771.5 1210.5 771.5C1209.4 771.5 1208.5 772.395 1208.5 773.5C1208.5 774.605 1209.4 775.5 1210.5 775.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1259.5 775.5C1260.6 775.5 1261.5 774.605 1261.5 773.5C1261.5 772.395 1260.6 771.5 1259.5 771.5C1258.4 771.5 1257.5 772.395 1257.5 773.5C1257.5 774.605 1258.4 775.5 1259.5 775.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1308.5 775.5C1309.6 775.5 1310.5 774.605 1310.5 773.5C1310.5 772.395 1309.6 771.5 1308.5 771.5C1307.4 771.5 1306.5 772.395 1306.5 773.5C1306.5 774.605 1307.4 775.5 1308.5 775.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1357.5 775.5C1358.6 775.5 1359.5 774.605 1359.5 773.5C1359.5 772.395 1358.6 771.5 1357.5 771.5C1356.4 771.5 1355.5 772.395 1355.5 773.5C1355.5 774.605 1356.4 775.5 1357.5 775.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1406.5 775.5C1407.6 775.5 1408.5 774.605 1408.5 773.5C1408.5 772.395 1407.6 771.5 1406.5 771.5C1405.4 771.5 1404.5 772.395 1404.5 773.5C1404.5 774.605 1405.4 775.5 1406.5 775.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.5 824.5C35.6046 824.5 36.5 823.605 36.5 822.5C36.5 821.395 35.6046 820.5 34.5 820.5C33.3954 820.5 32.5 821.395 32.5 822.5C32.5 823.605 33.3954 824.5 34.5 824.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.5 824.5C84.6046 824.5 85.5 823.605 85.5 822.5C85.5 821.395 84.6046 820.5 83.5 820.5C82.3954 820.5 81.5 821.395 81.5 822.5C81.5 823.605 82.3954 824.5 83.5 824.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132.5 824.5C133.605 824.5 134.5 823.605 134.5 822.5C134.5 821.395 133.605 820.5 132.5 820.5C131.395 820.5 130.5 821.395 130.5 822.5C130.5 823.605 131.395 824.5 132.5 824.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M181.5 824.5C182.605 824.5 183.5 823.605 183.5 822.5C183.5 821.395 182.605 820.5 181.5 820.5C180.395 820.5 179.5 821.395 179.5 822.5C179.5 823.605 180.395 824.5 181.5 824.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M230.5 824.5C231.605 824.5 232.5 823.605 232.5 822.5C232.5 821.395 231.605 820.5 230.5 820.5C229.395 820.5 228.5 821.395 228.5 822.5C228.5 823.605 229.395 824.5 230.5 824.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M279.5 824.5C280.605 824.5 281.5 823.605 281.5 822.5C281.5 821.395 280.605 820.5 279.5 820.5C278.395 820.5 277.5 821.395 277.5 822.5C277.5 823.605 278.395 824.5 279.5 824.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M328.5 824.5C329.605 824.5 330.5 823.605 330.5 822.5C330.5 821.395 329.605 820.5 328.5 820.5C327.395 820.5 326.5 821.395 326.5 822.5C326.5 823.605 327.395 824.5 328.5 824.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M377.5 824.5C378.605 824.5 379.5 823.605 379.5 822.5C379.5 821.395 378.605 820.5 377.5 820.5C376.395 820.5 375.5 821.395 375.5 822.5C375.5 823.605 376.395 824.5 377.5 824.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M426.5 824.5C427.605 824.5 428.5 823.605 428.5 822.5C428.5 821.395 427.605 820.5 426.5 820.5C425.395 820.5 424.5 821.395 424.5 822.5C424.5 823.605 425.395 824.5 426.5 824.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M475.5 824.5C476.605 824.5 477.5 823.605 477.5 822.5C477.5 821.395 476.605 820.5 475.5 820.5C474.395 820.5 473.5 821.395 473.5 822.5C473.5 823.605 474.395 824.5 475.5 824.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M524.5 824.5C525.605 824.5 526.5 823.605 526.5 822.5C526.5 821.395 525.605 820.5 524.5 820.5C523.395 820.5 522.5 821.395 522.5 822.5C522.5 823.605 523.395 824.5 524.5 824.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M573.5 824.5C574.605 824.5 575.5 823.605 575.5 822.5C575.5 821.395 574.605 820.5 573.5 820.5C572.395 820.5 571.5 821.395 571.5 822.5C571.5 823.605 572.395 824.5 573.5 824.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M622.5 824.5C623.605 824.5 624.5 823.605 624.5 822.5C624.5 821.395 623.605 820.5 622.5 820.5C621.395 820.5 620.5 821.395 620.5 822.5C620.5 823.605 621.395 824.5 622.5 824.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M671.5 824.5C672.605 824.5 673.5 823.605 673.5 822.5C673.5 821.395 672.605 820.5 671.5 820.5C670.395 820.5 669.5 821.395 669.5 822.5C669.5 823.605 670.395 824.5 671.5 824.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M720.5 824.5C721.605 824.5 722.5 823.605 722.5 822.5C722.5 821.395 721.605 820.5 720.5 820.5C719.395 820.5 718.5 821.395 718.5 822.5C718.5 823.605 719.395 824.5 720.5 824.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M769.5 824.5C770.605 824.5 771.5 823.605 771.5 822.5C771.5 821.395 770.605 820.5 769.5 820.5C768.395 820.5 767.5 821.395 767.5 822.5C767.5 823.605 768.395 824.5 769.5 824.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M818.5 824.5C819.605 824.5 820.5 823.605 820.5 822.5C820.5 821.395 819.605 820.5 818.5 820.5C817.395 820.5 816.5 821.395 816.5 822.5C816.5 823.605 817.395 824.5 818.5 824.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M867.5 824.5C868.605 824.5 869.5 823.605 869.5 822.5C869.5 821.395 868.605 820.5 867.5 820.5C866.395 820.5 865.5 821.395 865.5 822.5C865.5 823.605 866.395 824.5 867.5 824.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M916.5 824.5C917.605 824.5 918.5 823.605 918.5 822.5C918.5 821.395 917.605 820.5 916.5 820.5C915.395 820.5 914.5 821.395 914.5 822.5C914.5 823.605 915.395 824.5 916.5 824.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M965.5 824.5C966.605 824.5 967.5 823.605 967.5 822.5C967.5 821.395 966.605 820.5 965.5 820.5C964.395 820.5 963.5 821.395 963.5 822.5C963.5 823.605 964.395 824.5 965.5 824.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1014.5 824.5C1015.6 824.5 1016.5 823.605 1016.5 822.5C1016.5 821.395 1015.6 820.5 1014.5 820.5C1013.4 820.5 1012.5 821.395 1012.5 822.5C1012.5 823.605 1013.4 824.5 1014.5 824.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1063.5 824.5C1064.6 824.5 1065.5 823.605 1065.5 822.5C1065.5 821.395 1064.6 820.5 1063.5 820.5C1062.4 820.5 1061.5 821.395 1061.5 822.5C1061.5 823.605 1062.4 824.5 1063.5 824.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1112.5 824.5C1113.6 824.5 1114.5 823.605 1114.5 822.5C1114.5 821.395 1113.6 820.5 1112.5 820.5C1111.4 820.5 1110.5 821.395 1110.5 822.5C1110.5 823.605 1111.4 824.5 1112.5 824.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1161.5 824.5C1162.6 824.5 1163.5 823.605 1163.5 822.5C1163.5 821.395 1162.6 820.5 1161.5 820.5C1160.4 820.5 1159.5 821.395 1159.5 822.5C1159.5 823.605 1160.4 824.5 1161.5 824.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1210.5 824.5C1211.6 824.5 1212.5 823.605 1212.5 822.5C1212.5 821.395 1211.6 820.5 1210.5 820.5C1209.4 820.5 1208.5 821.395 1208.5 822.5C1208.5 823.605 1209.4 824.5 1210.5 824.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1259.5 824.5C1260.6 824.5 1261.5 823.605 1261.5 822.5C1261.5 821.395 1260.6 820.5 1259.5 820.5C1258.4 820.5 1257.5 821.395 1257.5 822.5C1257.5 823.605 1258.4 824.5 1259.5 824.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1308.5 824.5C1309.6 824.5 1310.5 823.605 1310.5 822.5C1310.5 821.395 1309.6 820.5 1308.5 820.5C1307.4 820.5 1306.5 821.395 1306.5 822.5C1306.5 823.605 1307.4 824.5 1308.5 824.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1357.5 824.5C1358.6 824.5 1359.5 823.605 1359.5 822.5C1359.5 821.395 1358.6 820.5 1357.5 820.5C1356.4 820.5 1355.5 821.395 1355.5 822.5C1355.5 823.605 1356.4 824.5 1357.5 824.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1406.5 824.5C1407.6 824.5 1408.5 823.605 1408.5 822.5C1408.5 821.395 1407.6 820.5 1406.5 820.5C1405.4 820.5 1404.5 821.395 1404.5 822.5C1404.5 823.605 1405.4 824.5 1406.5 824.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.5 873.5C35.6046 873.5 36.5 872.605 36.5 871.5C36.5 870.395 35.6046 869.5 34.5 869.5C33.3954 869.5 32.5 870.395 32.5 871.5C32.5 872.605 33.3954 873.5 34.5 873.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.5 873.5C84.6046 873.5 85.5 872.605 85.5 871.5C85.5 870.395 84.6046 869.5 83.5 869.5C82.3954 869.5 81.5 870.395 81.5 871.5C81.5 872.605 82.3954 873.5 83.5 873.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132.5 873.5C133.605 873.5 134.5 872.605 134.5 871.5C134.5 870.395 133.605 869.5 132.5 869.5C131.395 869.5 130.5 870.395 130.5 871.5C130.5 872.605 131.395 873.5 132.5 873.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M181.5 873.5C182.605 873.5 183.5 872.605 183.5 871.5C183.5 870.395 182.605 869.5 181.5 869.5C180.395 869.5 179.5 870.395 179.5 871.5C179.5 872.605 180.395 873.5 181.5 873.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M230.5 873.5C231.605 873.5 232.5 872.605 232.5 871.5C232.5 870.395 231.605 869.5 230.5 869.5C229.395 869.5 228.5 870.395 228.5 871.5C228.5 872.605 229.395 873.5 230.5 873.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M279.5 873.5C280.605 873.5 281.5 872.605 281.5 871.5C281.5 870.395 280.605 869.5 279.5 869.5C278.395 869.5 277.5 870.395 277.5 871.5C277.5 872.605 278.395 873.5 279.5 873.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M328.5 873.5C329.605 873.5 330.5 872.605 330.5 871.5C330.5 870.395 329.605 869.5 328.5 869.5C327.395 869.5 326.5 870.395 326.5 871.5C326.5 872.605 327.395 873.5 328.5 873.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M377.5 873.5C378.605 873.5 379.5 872.605 379.5 871.5C379.5 870.395 378.605 869.5 377.5 869.5C376.395 869.5 375.5 870.395 375.5 871.5C375.5 872.605 376.395 873.5 377.5 873.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M426.5 873.5C427.605 873.5 428.5 872.605 428.5 871.5C428.5 870.395 427.605 869.5 426.5 869.5C425.395 869.5 424.5 870.395 424.5 871.5C424.5 872.605 425.395 873.5 426.5 873.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M475.5 873.5C476.605 873.5 477.5 872.605 477.5 871.5C477.5 870.395 476.605 869.5 475.5 869.5C474.395 869.5 473.5 870.395 473.5 871.5C473.5 872.605 474.395 873.5 475.5 873.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M524.5 873.5C525.605 873.5 526.5 872.605 526.5 871.5C526.5 870.395 525.605 869.5 524.5 869.5C523.395 869.5 522.5 870.395 522.5 871.5C522.5 872.605 523.395 873.5 524.5 873.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M573.5 873.5C574.605 873.5 575.5 872.605 575.5 871.5C575.5 870.395 574.605 869.5 573.5 869.5C572.395 869.5 571.5 870.395 571.5 871.5C571.5 872.605 572.395 873.5 573.5 873.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M622.5 873.5C623.605 873.5 624.5 872.605 624.5 871.5C624.5 870.395 623.605 869.5 622.5 869.5C621.395 869.5 620.5 870.395 620.5 871.5C620.5 872.605 621.395 873.5 622.5 873.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M671.5 873.5C672.605 873.5 673.5 872.605 673.5 871.5C673.5 870.395 672.605 869.5 671.5 869.5C670.395 869.5 669.5 870.395 669.5 871.5C669.5 872.605 670.395 873.5 671.5 873.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M720.5 873.5C721.605 873.5 722.5 872.605 722.5 871.5C722.5 870.395 721.605 869.5 720.5 869.5C719.395 869.5 718.5 870.395 718.5 871.5C718.5 872.605 719.395 873.5 720.5 873.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M769.5 873.5C770.605 873.5 771.5 872.605 771.5 871.5C771.5 870.395 770.605 869.5 769.5 869.5C768.395 869.5 767.5 870.395 767.5 871.5C767.5 872.605 768.395 873.5 769.5 873.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M818.5 873.5C819.605 873.5 820.5 872.605 820.5 871.5C820.5 870.395 819.605 869.5 818.5 869.5C817.395 869.5 816.5 870.395 816.5 871.5C816.5 872.605 817.395 873.5 818.5 873.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M867.5 873.5C868.605 873.5 869.5 872.605 869.5 871.5C869.5 870.395 868.605 869.5 867.5 869.5C866.395 869.5 865.5 870.395 865.5 871.5C865.5 872.605 866.395 873.5 867.5 873.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M916.5 873.5C917.605 873.5 918.5 872.605 918.5 871.5C918.5 870.395 917.605 869.5 916.5 869.5C915.395 869.5 914.5 870.395 914.5 871.5C914.5 872.605 915.395 873.5 916.5 873.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M965.5 873.5C966.605 873.5 967.5 872.605 967.5 871.5C967.5 870.395 966.605 869.5 965.5 869.5C964.395 869.5 963.5 870.395 963.5 871.5C963.5 872.605 964.395 873.5 965.5 873.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1014.5 873.5C1015.6 873.5 1016.5 872.605 1016.5 871.5C1016.5 870.395 1015.6 869.5 1014.5 869.5C1013.4 869.5 1012.5 870.395 1012.5 871.5C1012.5 872.605 1013.4 873.5 1014.5 873.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1063.5 873.5C1064.6 873.5 1065.5 872.605 1065.5 871.5C1065.5 870.395 1064.6 869.5 1063.5 869.5C1062.4 869.5 1061.5 870.395 1061.5 871.5C1061.5 872.605 1062.4 873.5 1063.5 873.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1112.5 873.5C1113.6 873.5 1114.5 872.605 1114.5 871.5C1114.5 870.395 1113.6 869.5 1112.5 869.5C1111.4 869.5 1110.5 870.395 1110.5 871.5C1110.5 872.605 1111.4 873.5 1112.5 873.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1161.5 873.5C1162.6 873.5 1163.5 872.605 1163.5 871.5C1163.5 870.395 1162.6 869.5 1161.5 869.5C1160.4 869.5 1159.5 870.395 1159.5 871.5C1159.5 872.605 1160.4 873.5 1161.5 873.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1210.5 873.5C1211.6 873.5 1212.5 872.605 1212.5 871.5C1212.5 870.395 1211.6 869.5 1210.5 869.5C1209.4 869.5 1208.5 870.395 1208.5 871.5C1208.5 872.605 1209.4 873.5 1210.5 873.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1259.5 873.5C1260.6 873.5 1261.5 872.605 1261.5 871.5C1261.5 870.395 1260.6 869.5 1259.5 869.5C1258.4 869.5 1257.5 870.395 1257.5 871.5C1257.5 872.605 1258.4 873.5 1259.5 873.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1308.5 873.5C1309.6 873.5 1310.5 872.605 1310.5 871.5C1310.5 870.395 1309.6 869.5 1308.5 869.5C1307.4 869.5 1306.5 870.395 1306.5 871.5C1306.5 872.605 1307.4 873.5 1308.5 873.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1357.5 873.5C1358.6 873.5 1359.5 872.605 1359.5 871.5C1359.5 870.395 1358.6 869.5 1357.5 869.5C1356.4 869.5 1355.5 870.395 1355.5 871.5C1355.5 872.605 1356.4 873.5 1357.5 873.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1406.5 873.5C1407.6 873.5 1408.5 872.605 1408.5 871.5C1408.5 870.395 1407.6 869.5 1406.5 869.5C1405.4 869.5 1404.5 870.395 1404.5 871.5C1404.5 872.605 1405.4 873.5 1406.5 873.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.5 922.5C35.6046 922.5 36.5 921.605 36.5 920.5C36.5 919.395 35.6046 918.5 34.5 918.5C33.3954 918.5 32.5 919.395 32.5 920.5C32.5 921.605 33.3954 922.5 34.5 922.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.5 922.5C84.6046 922.5 85.5 921.605 85.5 920.5C85.5 919.395 84.6046 918.5 83.5 918.5C82.3954 918.5 81.5 919.395 81.5 920.5C81.5 921.605 82.3954 922.5 83.5 922.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132.5 922.5C133.605 922.5 134.5 921.605 134.5 920.5C134.5 919.395 133.605 918.5 132.5 918.5C131.395 918.5 130.5 919.395 130.5 920.5C130.5 921.605 131.395 922.5 132.5 922.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M181.5 922.5C182.605 922.5 183.5 921.605 183.5 920.5C183.5 919.395 182.605 918.5 181.5 918.5C180.395 918.5 179.5 919.395 179.5 920.5C179.5 921.605 180.395 922.5 181.5 922.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M230.5 922.5C231.605 922.5 232.5 921.605 232.5 920.5C232.5 919.395 231.605 918.5 230.5 918.5C229.395 918.5 228.5 919.395 228.5 920.5C228.5 921.605 229.395 922.5 230.5 922.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M279.5 922.5C280.605 922.5 281.5 921.605 281.5 920.5C281.5 919.395 280.605 918.5 279.5 918.5C278.395 918.5 277.5 919.395 277.5 920.5C277.5 921.605 278.395 922.5 279.5 922.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M328.5 922.5C329.605 922.5 330.5 921.605 330.5 920.5C330.5 919.395 329.605 918.5 328.5 918.5C327.395 918.5 326.5 919.395 326.5 920.5C326.5 921.605 327.395 922.5 328.5 922.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M377.5 922.5C378.605 922.5 379.5 921.605 379.5 920.5C379.5 919.395 378.605 918.5 377.5 918.5C376.395 918.5 375.5 919.395 375.5 920.5C375.5 921.605 376.395 922.5 377.5 922.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M426.5 922.5C427.605 922.5 428.5 921.605 428.5 920.5C428.5 919.395 427.605 918.5 426.5 918.5C425.395 918.5 424.5 919.395 424.5 920.5C424.5 921.605 425.395 922.5 426.5 922.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M475.5 922.5C476.605 922.5 477.5 921.605 477.5 920.5C477.5 919.395 476.605 918.5 475.5 918.5C474.395 918.5 473.5 919.395 473.5 920.5C473.5 921.605 474.395 922.5 475.5 922.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M524.5 922.5C525.605 922.5 526.5 921.605 526.5 920.5C526.5 919.395 525.605 918.5 524.5 918.5C523.395 918.5 522.5 919.395 522.5 920.5C522.5 921.605 523.395 922.5 524.5 922.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M573.5 922.5C574.605 922.5 575.5 921.605 575.5 920.5C575.5 919.395 574.605 918.5 573.5 918.5C572.395 918.5 571.5 919.395 571.5 920.5C571.5 921.605 572.395 922.5 573.5 922.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M622.5 922.5C623.605 922.5 624.5 921.605 624.5 920.5C624.5 919.395 623.605 918.5 622.5 918.5C621.395 918.5 620.5 919.395 620.5 920.5C620.5 921.605 621.395 922.5 622.5 922.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M671.5 922.5C672.605 922.5 673.5 921.605 673.5 920.5C673.5 919.395 672.605 918.5 671.5 918.5C670.395 918.5 669.5 919.395 669.5 920.5C669.5 921.605 670.395 922.5 671.5 922.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M720.5 922.5C721.605 922.5 722.5 921.605 722.5 920.5C722.5 919.395 721.605 918.5 720.5 918.5C719.395 918.5 718.5 919.395 718.5 920.5C718.5 921.605 719.395 922.5 720.5 922.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M769.5 922.5C770.605 922.5 771.5 921.605 771.5 920.5C771.5 919.395 770.605 918.5 769.5 918.5C768.395 918.5 767.5 919.395 767.5 920.5C767.5 921.605 768.395 922.5 769.5 922.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M818.5 922.5C819.605 922.5 820.5 921.605 820.5 920.5C820.5 919.395 819.605 918.5 818.5 918.5C817.395 918.5 816.5 919.395 816.5 920.5C816.5 921.605 817.395 922.5 818.5 922.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M867.5 922.5C868.605 922.5 869.5 921.605 869.5 920.5C869.5 919.395 868.605 918.5 867.5 918.5C866.395 918.5 865.5 919.395 865.5 920.5C865.5 921.605 866.395 922.5 867.5 922.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M916.5 922.5C917.605 922.5 918.5 921.605 918.5 920.5C918.5 919.395 917.605 918.5 916.5 918.5C915.395 918.5 914.5 919.395 914.5 920.5C914.5 921.605 915.395 922.5 916.5 922.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M965.5 922.5C966.605 922.5 967.5 921.605 967.5 920.5C967.5 919.395 966.605 918.5 965.5 918.5C964.395 918.5 963.5 919.395 963.5 920.5C963.5 921.605 964.395 922.5 965.5 922.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1014.5 922.5C1015.6 922.5 1016.5 921.605 1016.5 920.5C1016.5 919.395 1015.6 918.5 1014.5 918.5C1013.4 918.5 1012.5 919.395 1012.5 920.5C1012.5 921.605 1013.4 922.5 1014.5 922.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1063.5 922.5C1064.6 922.5 1065.5 921.605 1065.5 920.5C1065.5 919.395 1064.6 918.5 1063.5 918.5C1062.4 918.5 1061.5 919.395 1061.5 920.5C1061.5 921.605 1062.4 922.5 1063.5 922.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1112.5 922.5C1113.6 922.5 1114.5 921.605 1114.5 920.5C1114.5 919.395 1113.6 918.5 1112.5 918.5C1111.4 918.5 1110.5 919.395 1110.5 920.5C1110.5 921.605 1111.4 922.5 1112.5 922.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1161.5 922.5C1162.6 922.5 1163.5 921.605 1163.5 920.5C1163.5 919.395 1162.6 918.5 1161.5 918.5C1160.4 918.5 1159.5 919.395 1159.5 920.5C1159.5 921.605 1160.4 922.5 1161.5 922.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1210.5 922.5C1211.6 922.5 1212.5 921.605 1212.5 920.5C1212.5 919.395 1211.6 918.5 1210.5 918.5C1209.4 918.5 1208.5 919.395 1208.5 920.5C1208.5 921.605 1209.4 922.5 1210.5 922.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1259.5 922.5C1260.6 922.5 1261.5 921.605 1261.5 920.5C1261.5 919.395 1260.6 918.5 1259.5 918.5C1258.4 918.5 1257.5 919.395 1257.5 920.5C1257.5 921.605 1258.4 922.5 1259.5 922.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1308.5 922.5C1309.6 922.5 1310.5 921.605 1310.5 920.5C1310.5 919.395 1309.6 918.5 1308.5 918.5C1307.4 918.5 1306.5 919.395 1306.5 920.5C1306.5 921.605 1307.4 922.5 1308.5 922.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1357.5 922.5C1358.6 922.5 1359.5 921.605 1359.5 920.5C1359.5 919.395 1358.6 918.5 1357.5 918.5C1356.4 918.5 1355.5 919.395 1355.5 920.5C1355.5 921.605 1356.4 922.5 1357.5 922.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1406.5 922.5C1407.6 922.5 1408.5 921.605 1408.5 920.5C1408.5 919.395 1407.6 918.5 1406.5 918.5C1405.4 918.5 1404.5 919.395 1404.5 920.5C1404.5 921.605 1405.4 922.5 1406.5 922.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.5 971.5C35.6046 971.5 36.5 970.605 36.5 969.5C36.5 968.395 35.6046 967.5 34.5 967.5C33.3954 967.5 32.5 968.395 32.5 969.5C32.5 970.605 33.3954 971.5 34.5 971.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.5 971.5C84.6046 971.5 85.5 970.605 85.5 969.5C85.5 968.395 84.6046 967.5 83.5 967.5C82.3954 967.5 81.5 968.395 81.5 969.5C81.5 970.605 82.3954 971.5 83.5 971.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132.5 971.5C133.605 971.5 134.5 970.605 134.5 969.5C134.5 968.395 133.605 967.5 132.5 967.5C131.395 967.5 130.5 968.395 130.5 969.5C130.5 970.605 131.395 971.5 132.5 971.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M181.5 971.5C182.605 971.5 183.5 970.605 183.5 969.5C183.5 968.395 182.605 967.5 181.5 967.5C180.395 967.5 179.5 968.395 179.5 969.5C179.5 970.605 180.395 971.5 181.5 971.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M230.5 971.5C231.605 971.5 232.5 970.605 232.5 969.5C232.5 968.395 231.605 967.5 230.5 967.5C229.395 967.5 228.5 968.395 228.5 969.5C228.5 970.605 229.395 971.5 230.5 971.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M279.5 971.5C280.605 971.5 281.5 970.605 281.5 969.5C281.5 968.395 280.605 967.5 279.5 967.5C278.395 967.5 277.5 968.395 277.5 969.5C277.5 970.605 278.395 971.5 279.5 971.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M328.5 971.5C329.605 971.5 330.5 970.605 330.5 969.5C330.5 968.395 329.605 967.5 328.5 967.5C327.395 967.5 326.5 968.395 326.5 969.5C326.5 970.605 327.395 971.5 328.5 971.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M377.5 971.5C378.605 971.5 379.5 970.605 379.5 969.5C379.5 968.395 378.605 967.5 377.5 967.5C376.395 967.5 375.5 968.395 375.5 969.5C375.5 970.605 376.395 971.5 377.5 971.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M426.5 971.5C427.605 971.5 428.5 970.605 428.5 969.5C428.5 968.395 427.605 967.5 426.5 967.5C425.395 967.5 424.5 968.395 424.5 969.5C424.5 970.605 425.395 971.5 426.5 971.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M475.5 971.5C476.605 971.5 477.5 970.605 477.5 969.5C477.5 968.395 476.605 967.5 475.5 967.5C474.395 967.5 473.5 968.395 473.5 969.5C473.5 970.605 474.395 971.5 475.5 971.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M524.5 971.5C525.605 971.5 526.5 970.605 526.5 969.5C526.5 968.395 525.605 967.5 524.5 967.5C523.395 967.5 522.5 968.395 522.5 969.5C522.5 970.605 523.395 971.5 524.5 971.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M573.5 971.5C574.605 971.5 575.5 970.605 575.5 969.5C575.5 968.395 574.605 967.5 573.5 967.5C572.395 967.5 571.5 968.395 571.5 969.5C571.5 970.605 572.395 971.5 573.5 971.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M622.5 971.5C623.605 971.5 624.5 970.605 624.5 969.5C624.5 968.395 623.605 967.5 622.5 967.5C621.395 967.5 620.5 968.395 620.5 969.5C620.5 970.605 621.395 971.5 622.5 971.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M671.5 971.5C672.605 971.5 673.5 970.605 673.5 969.5C673.5 968.395 672.605 967.5 671.5 967.5C670.395 967.5 669.5 968.395 669.5 969.5C669.5 970.605 670.395 971.5 671.5 971.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M720.5 971.5C721.605 971.5 722.5 970.605 722.5 969.5C722.5 968.395 721.605 967.5 720.5 967.5C719.395 967.5 718.5 968.395 718.5 969.5C718.5 970.605 719.395 971.5 720.5 971.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M769.5 971.5C770.605 971.5 771.5 970.605 771.5 969.5C771.5 968.395 770.605 967.5 769.5 967.5C768.395 967.5 767.5 968.395 767.5 969.5C767.5 970.605 768.395 971.5 769.5 971.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M818.5 971.5C819.605 971.5 820.5 970.605 820.5 969.5C820.5 968.395 819.605 967.5 818.5 967.5C817.395 967.5 816.5 968.395 816.5 969.5C816.5 970.605 817.395 971.5 818.5 971.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M867.5 971.5C868.605 971.5 869.5 970.605 869.5 969.5C869.5 968.395 868.605 967.5 867.5 967.5C866.395 967.5 865.5 968.395 865.5 969.5C865.5 970.605 866.395 971.5 867.5 971.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M916.5 971.5C917.605 971.5 918.5 970.605 918.5 969.5C918.5 968.395 917.605 967.5 916.5 967.5C915.395 967.5 914.5 968.395 914.5 969.5C914.5 970.605 915.395 971.5 916.5 971.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M965.5 971.5C966.605 971.5 967.5 970.605 967.5 969.5C967.5 968.395 966.605 967.5 965.5 967.5C964.395 967.5 963.5 968.395 963.5 969.5C963.5 970.605 964.395 971.5 965.5 971.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1014.5 971.5C1015.6 971.5 1016.5 970.605 1016.5 969.5C1016.5 968.395 1015.6 967.5 1014.5 967.5C1013.4 967.5 1012.5 968.395 1012.5 969.5C1012.5 970.605 1013.4 971.5 1014.5 971.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1063.5 971.5C1064.6 971.5 1065.5 970.605 1065.5 969.5C1065.5 968.395 1064.6 967.5 1063.5 967.5C1062.4 967.5 1061.5 968.395 1061.5 969.5C1061.5 970.605 1062.4 971.5 1063.5 971.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1112.5 971.5C1113.6 971.5 1114.5 970.605 1114.5 969.5C1114.5 968.395 1113.6 967.5 1112.5 967.5C1111.4 967.5 1110.5 968.395 1110.5 969.5C1110.5 970.605 1111.4 971.5 1112.5 971.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1161.5 971.5C1162.6 971.5 1163.5 970.605 1163.5 969.5C1163.5 968.395 1162.6 967.5 1161.5 967.5C1160.4 967.5 1159.5 968.395 1159.5 969.5C1159.5 970.605 1160.4 971.5 1161.5 971.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1210.5 971.5C1211.6 971.5 1212.5 970.605 1212.5 969.5C1212.5 968.395 1211.6 967.5 1210.5 967.5C1209.4 967.5 1208.5 968.395 1208.5 969.5C1208.5 970.605 1209.4 971.5 1210.5 971.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1259.5 971.5C1260.6 971.5 1261.5 970.605 1261.5 969.5C1261.5 968.395 1260.6 967.5 1259.5 967.5C1258.4 967.5 1257.5 968.395 1257.5 969.5C1257.5 970.605 1258.4 971.5 1259.5 971.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1308.5 971.5C1309.6 971.5 1310.5 970.605 1310.5 969.5C1310.5 968.395 1309.6 967.5 1308.5 967.5C1307.4 967.5 1306.5 968.395 1306.5 969.5C1306.5 970.605 1307.4 971.5 1308.5 971.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1357.5 971.5C1358.6 971.5 1359.5 970.605 1359.5 969.5C1359.5 968.395 1358.6 967.5 1357.5 967.5C1356.4 967.5 1355.5 968.395 1355.5 969.5C1355.5 970.605 1356.4 971.5 1357.5 971.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1406.5 971.5C1407.6 971.5 1408.5 970.605 1408.5 969.5C1408.5 968.395 1407.6 967.5 1406.5 967.5C1405.4 967.5 1404.5 968.395 1404.5 969.5C1404.5 970.605 1405.4 971.5 1406.5 971.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.5 1020.5C35.6046 1020.5 36.5 1019.6 36.5 1018.5C36.5 1017.4 35.6046 1016.5 34.5 1016.5C33.3954 1016.5 32.5 1017.4 32.5 1018.5C32.5 1019.6 33.3954 1020.5 34.5 1020.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.5 1020.5C84.6046 1020.5 85.5 1019.6 85.5 1018.5C85.5 1017.4 84.6046 1016.5 83.5 1016.5C82.3954 1016.5 81.5 1017.4 81.5 1018.5C81.5 1019.6 82.3954 1020.5 83.5 1020.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132.5 1020.5C133.605 1020.5 134.5 1019.6 134.5 1018.5C134.5 1017.4 133.605 1016.5 132.5 1016.5C131.395 1016.5 130.5 1017.4 130.5 1018.5C130.5 1019.6 131.395 1020.5 132.5 1020.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M181.5 1020.5C182.605 1020.5 183.5 1019.6 183.5 1018.5C183.5 1017.4 182.605 1016.5 181.5 1016.5C180.395 1016.5 179.5 1017.4 179.5 1018.5C179.5 1019.6 180.395 1020.5 181.5 1020.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M230.5 1020.5C231.605 1020.5 232.5 1019.6 232.5 1018.5C232.5 1017.4 231.605 1016.5 230.5 1016.5C229.395 1016.5 228.5 1017.4 228.5 1018.5C228.5 1019.6 229.395 1020.5 230.5 1020.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M279.5 1020.5C280.605 1020.5 281.5 1019.6 281.5 1018.5C281.5 1017.4 280.605 1016.5 279.5 1016.5C278.395 1016.5 277.5 1017.4 277.5 1018.5C277.5 1019.6 278.395 1020.5 279.5 1020.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M328.5 1020.5C329.605 1020.5 330.5 1019.6 330.5 1018.5C330.5 1017.4 329.605 1016.5 328.5 1016.5C327.395 1016.5 326.5 1017.4 326.5 1018.5C326.5 1019.6 327.395 1020.5 328.5 1020.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M377.5 1020.5C378.605 1020.5 379.5 1019.6 379.5 1018.5C379.5 1017.4 378.605 1016.5 377.5 1016.5C376.395 1016.5 375.5 1017.4 375.5 1018.5C375.5 1019.6 376.395 1020.5 377.5 1020.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M426.5 1020.5C427.605 1020.5 428.5 1019.6 428.5 1018.5C428.5 1017.4 427.605 1016.5 426.5 1016.5C425.395 1016.5 424.5 1017.4 424.5 1018.5C424.5 1019.6 425.395 1020.5 426.5 1020.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M475.5 1020.5C476.605 1020.5 477.5 1019.6 477.5 1018.5C477.5 1017.4 476.605 1016.5 475.5 1016.5C474.395 1016.5 473.5 1017.4 473.5 1018.5C473.5 1019.6 474.395 1020.5 475.5 1020.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M524.5 1020.5C525.605 1020.5 526.5 1019.6 526.5 1018.5C526.5 1017.4 525.605 1016.5 524.5 1016.5C523.395 1016.5 522.5 1017.4 522.5 1018.5C522.5 1019.6 523.395 1020.5 524.5 1020.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M573.5 1020.5C574.605 1020.5 575.5 1019.6 575.5 1018.5C575.5 1017.4 574.605 1016.5 573.5 1016.5C572.395 1016.5 571.5 1017.4 571.5 1018.5C571.5 1019.6 572.395 1020.5 573.5 1020.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M622.5 1020.5C623.605 1020.5 624.5 1019.6 624.5 1018.5C624.5 1017.4 623.605 1016.5 622.5 1016.5C621.395 1016.5 620.5 1017.4 620.5 1018.5C620.5 1019.6 621.395 1020.5 622.5 1020.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M671.5 1020.5C672.605 1020.5 673.5 1019.6 673.5 1018.5C673.5 1017.4 672.605 1016.5 671.5 1016.5C670.395 1016.5 669.5 1017.4 669.5 1018.5C669.5 1019.6 670.395 1020.5 671.5 1020.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M720.5 1020.5C721.605 1020.5 722.5 1019.6 722.5 1018.5C722.5 1017.4 721.605 1016.5 720.5 1016.5C719.395 1016.5 718.5 1017.4 718.5 1018.5C718.5 1019.6 719.395 1020.5 720.5 1020.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M769.5 1020.5C770.605 1020.5 771.5 1019.6 771.5 1018.5C771.5 1017.4 770.605 1016.5 769.5 1016.5C768.395 1016.5 767.5 1017.4 767.5 1018.5C767.5 1019.6 768.395 1020.5 769.5 1020.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M818.5 1020.5C819.605 1020.5 820.5 1019.6 820.5 1018.5C820.5 1017.4 819.605 1016.5 818.5 1016.5C817.395 1016.5 816.5 1017.4 816.5 1018.5C816.5 1019.6 817.395 1020.5 818.5 1020.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M867.5 1020.5C868.605 1020.5 869.5 1019.6 869.5 1018.5C869.5 1017.4 868.605 1016.5 867.5 1016.5C866.395 1016.5 865.5 1017.4 865.5 1018.5C865.5 1019.6 866.395 1020.5 867.5 1020.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M916.5 1020.5C917.605 1020.5 918.5 1019.6 918.5 1018.5C918.5 1017.4 917.605 1016.5 916.5 1016.5C915.395 1016.5 914.5 1017.4 914.5 1018.5C914.5 1019.6 915.395 1020.5 916.5 1020.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M965.5 1020.5C966.605 1020.5 967.5 1019.6 967.5 1018.5C967.5 1017.4 966.605 1016.5 965.5 1016.5C964.395 1016.5 963.5 1017.4 963.5 1018.5C963.5 1019.6 964.395 1020.5 965.5 1020.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1014.5 1020.5C1015.6 1020.5 1016.5 1019.6 1016.5 1018.5C1016.5 1017.4 1015.6 1016.5 1014.5 1016.5C1013.4 1016.5 1012.5 1017.4 1012.5 1018.5C1012.5 1019.6 1013.4 1020.5 1014.5 1020.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1063.5 1020.5C1064.6 1020.5 1065.5 1019.6 1065.5 1018.5C1065.5 1017.4 1064.6 1016.5 1063.5 1016.5C1062.4 1016.5 1061.5 1017.4 1061.5 1018.5C1061.5 1019.6 1062.4 1020.5 1063.5 1020.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1112.5 1020.5C1113.6 1020.5 1114.5 1019.6 1114.5 1018.5C1114.5 1017.4 1113.6 1016.5 1112.5 1016.5C1111.4 1016.5 1110.5 1017.4 1110.5 1018.5C1110.5 1019.6 1111.4 1020.5 1112.5 1020.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1161.5 1020.5C1162.6 1020.5 1163.5 1019.6 1163.5 1018.5C1163.5 1017.4 1162.6 1016.5 1161.5 1016.5C1160.4 1016.5 1159.5 1017.4 1159.5 1018.5C1159.5 1019.6 1160.4 1020.5 1161.5 1020.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1210.5 1020.5C1211.6 1020.5 1212.5 1019.6 1212.5 1018.5C1212.5 1017.4 1211.6 1016.5 1210.5 1016.5C1209.4 1016.5 1208.5 1017.4 1208.5 1018.5C1208.5 1019.6 1209.4 1020.5 1210.5 1020.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1259.5 1020.5C1260.6 1020.5 1261.5 1019.6 1261.5 1018.5C1261.5 1017.4 1260.6 1016.5 1259.5 1016.5C1258.4 1016.5 1257.5 1017.4 1257.5 1018.5C1257.5 1019.6 1258.4 1020.5 1259.5 1020.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1308.5 1020.5C1309.6 1020.5 1310.5 1019.6 1310.5 1018.5C1310.5 1017.4 1309.6 1016.5 1308.5 1016.5C1307.4 1016.5 1306.5 1017.4 1306.5 1018.5C1306.5 1019.6 1307.4 1020.5 1308.5 1020.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1357.5 1020.5C1358.6 1020.5 1359.5 1019.6 1359.5 1018.5C1359.5 1017.4 1358.6 1016.5 1357.5 1016.5C1356.4 1016.5 1355.5 1017.4 1355.5 1018.5C1355.5 1019.6 1356.4 1020.5 1357.5 1020.5Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1406.5 1020.5C1407.6 1020.5 1408.5 1019.6 1408.5 1018.5C1408.5 1017.4 1407.6 1016.5 1406.5 1016.5C1405.4 1016.5 1404.5 1017.4 1404.5 1018.5C1404.5 1019.6 1405.4 1020.5 1406.5 1020.5Z",
  fill: "#272A2E"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.2
}, /*#__PURE__*/React.createElement("path", {
  d: "M662.096 524.658C656.163 539.414 663.257 556.21 677.942 562.172L699.427 508.734C684.742 502.772 668.029 509.901 662.096 524.658Z",
  fill: "url(#paint1_linear_53029_6911)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M697.816 534.72C691.035 551.585 699.144 570.78 715.926 577.593C732.708 584.407 751.81 576.259 758.59 559.395L697.816 534.72Z",
  fill: "url(#paint2_linear_53029_6911)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M754.369 460C775.347 468.517 785.482 492.511 777.006 513.591C768.53 534.672 744.654 544.856 723.676 536.339L754.369 460Z",
  fill: "url(#paint3_linear_53029_6911)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M679.706 491.847C684.791 479.199 699.117 473.088 711.704 478.198C724.291 483.309 730.372 497.705 725.287 510.353L679.706 491.847Z",
  fill: "url(#paint4_linear_53029_6911)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M698.776 509.014L677.667 561.516C663.554 555.496 656.792 539.191 662.56 524.844C668.328 510.498 684.463 503.491 698.776 509.014ZM716.114 577.13C699.743 570.483 691.752 551.87 698.096 535.374L757.937 559.669C751.099 575.965 732.485 583.776 716.114 577.13ZM724.327 536.061L754.644 460.655C775.051 469.231 784.853 492.734 776.542 513.405C768.231 534.075 744.934 544.138 724.327 536.061ZM680.36 491.573C685.502 479.493 699.341 473.719 711.516 478.662C723.691 483.605 729.655 497.42 725.005 509.699L680.36 491.573Z",
  stroke: "white",
  strokeOpacity: 0.08
}));

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial_53029_6911",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(720 528) rotate(90) scale(535.987 730.891)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.499349,
  stopColor: "white",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_53029_6911",
  x1: 780,
  y1: 520,
  x2: 660,
  y2: 520,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_53029_6911",
  x1: 780,
  y1: 520,
  x2: 660,
  y2: 520,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_53029_6911",
  x1: 780,
  y1: 520,
  x2: 660,
  y2: 520,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_53029_6911",
  x1: 780,
  y1: 520,
  x2: 660,
  y2: 520,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_53029_6911"
}, /*#__PURE__*/React.createElement("rect", {
  width: 1440,
  height: 1056,
  fill: "white"
})));

function SvgBackgroundGrid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1056,
    viewBox: "0 0 1440 1056",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_53029_6911)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_53029_6911",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 1056
  }, _ref2), _ref3), _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundGrid);
export default __webpack_public_path__ + "static/media/BackgroundGrid.cdf30997a05b8ac29df4d56f53bf3ee0.svg";
export { ForwardRef as ReactComponent };